<template>
<div class="main manage-products">
	<div class="list-view">

		<div v-if="!showDetail" class="sub-header list-sub-header">
			<div class="input-with-control">
				<input type="search" ref="search_term" v-model="filters.search_term" placeholder="Search..." @search="doSearch()" v-focus>
				<div class="button action input-go" @click="doSearch()"><i class="fas fa-search"></i></div>
			</div>
			<div style="margin: 0 0 0 0.5em;">
				<div v-if="getAdministratorFlag" style="margin: 0.66em 0 0 0;">
					<span :class="['pointer', 'far', filters.include_deactivated_distributors ? 'fa-check-square' : 'fa-square']" @click="toggleFilter('include_deactivated_distributors')"></span> <label>Include deactivated distributors</label>
				</div>
				<label v-else>Search here for a UPC, model, <br>SKU or product description.</label>
			</div>
			<div class="input-with-control">
				<input type="search" ref="search_term" v-model="filters.product_id" placeholder="Product ID..." @search="doSearch()" v-focus>
				<div class="button action input-go" @click="doSearch()"><i class="fas fa-search"></i></div>
			</div>
			<div style="margin: 0 0 0 0.5em;">
				<label>Search here for a<br>product / item ID.</label>
			</div>
			<div class="controls">
				<pagination v-if="showPagination" :paging="paging" @updatePage="goToPage"></pagination>
			</div>
		</div>

		<div v-else class="sub-header detail-sub-header">
			<div class="detail-title">{{ productDetail.info.short_description }}</div>
			<div class="previous-next">
				<template v-if="list.length > 0 && productDetail.product_id != 'new'">
					<span :class="['previous', { disabled: productDetailListIndex == 0 }]" @click="getPreviousItem()">&lang; Prev</span>
					<span :class="['next', { disabled: productDetailListIndex == list.length - 1 }]" @click="getNextItem()">Next &rang;</span>
				</template>
			</div>
			<div class="detail-title-meta" v-if="productDetail.product_id != 'new'"><label>Product ID: </label>{{ productDetail.product_id }}</div>
		</div>

		<div v-if="!showDetail" class="filters">

			<label>Department</label>
			<select v-model="filters.department_id" @change="setDepartment()">
				<option value="">Select...</option>
				<option v-for="(department, index) in departments" :value="department.department_id">{{ department.description }}</option>
			</select>

			<div v-if="loadingFilterLists" class="empty-list">
				Loading filters...
			</div>

			<div v-else>

				<div v-if="Object.keys(categories).length > 0">
					<label>Category</label>
					<select v-model="filters.category_id" @change="resetList()">
						<option value="">Select...</option>
						<option v-for="(category, index) in categories" :value="category.category_id">{{ category.description }}</option>
					</select>
				</div>

				<div v-if="Object.keys(calibers).length > 0" @change="resetList()">
					<label>Caliber</label>
					<select v-model="filters.caliber_id" @change="getList()">
						<option value="">Select...</option>
						<option v-for="(caliber, index) in calibers" :value="caliber.caliber_id">{{ caliber.description }}</option>
					</select>
				</div>

				<div v-if="productTypes.length > 0">
					<label>Item Type</label>
					<select v-model="filters.product_type_code" @change="resetList()">
						<option value="">Select...</option>
						<option v-for="(productType, index) in productTypes" :value="productType.product_type_code">{{ productType.description }}</option>
					</select>
				</div>

				<div v-if="owner == 'distributor' && filters.department_id">
					<label>Distributor</label>
					<select v-model="filters.distributor_id" @change="getList()">
						<option value="">Select...</option>
						<option v-for="(distributor, index) in distributors" :value="distributor.distributor_id">{{ distributor.company_name }}</option>
					</select>
				</div>

				<label>Manufacturer</label>
				<div v-if="Object.keys(manufacturers).length > 0">
					<select v-model="filters.manufacturer_id" @change="resetList()">
						<option value="">Select...</option>
						<option v-for="(manufacturer, index) in manufacturers" :value="manufacturer.manufacturer_id">{{ manufacturer.description }}</option>
					</select>
				</div>
				<div v-else class="input-with-control">
					<input type="text" v-model="filters.manufacturer" placeholder="Search..." @keyup.enter="getFilterList('manufacturer')">
					<div class="button action input-go" @click="getFilterList('manufacturer')"><i class="fas fa-search"></i></div>
				</div>

				<div v-if="gunBrokerEnabled">
					<label>GunBroker</label>
					<div>
						<select v-model="filters.gunbroker_status" @change="resetList()">
							<option value="">Select...</option>
							<option value="all">All GunBroker listed items</option>
							<option value="active">Active GunBroker listed items</option>
							<option value="sold">Sold GunBroker items</option>
							<option value="expired">Expired GunBroker items</option>
						</select>
					</div>
				</div>

			</div>

			<template v-if="owner == 'store'">
				<label @click="showListOnly = !showListOnly" class="pointer">
					<i :class="['fas', showListOnly ? 'fa-caret-down' : 'fa-caret-right']"></i>
					&nbsp;List Only...
				</label>
				<ul v-if="showListOnly" class="checkbox-group">
					<li>
						<span :class="['pointer', 'far', filters.in_stock ? 'fa-check-square' : 'fa-square']" @click="toggleFilter('in_stock')"></span>
						<label>In Stock</label>
					</li>
					<li>
						<span :class="['pointer', 'far', filters.out_of_stock ? 'fa-check-square' : 'fa-square']" @click="toggleFilter('out_of_stock')"></span>
						<label>Out Of Stock</label>
					</li>
					<li>
						<span :class="['pointer', 'far', filters.hidden ? 'fa-check-square' : 'fa-square']" @click="toggleFilter('hidden')"></span>
						<label>Hidden From Website</label>
					</li>
					<li>
						<span :class="['pointer', 'far', filters.deleted ? 'fa-check-square' : 'fa-square']" @click="toggleFilter('deleted')"></span>
						<label>Deactivated</label>
					</li>
					<li>
						<span :class="['pointer', 'far', filters.not_taxable ? 'fa-check-square' : 'fa-square']" @click="toggleFilter('not_taxable')"></span>
						<label>Not Taxable</label>
					</li>
					<li>
						<span :class="['pointer', 'far', filters.no_category ? 'fa-check-square' : 'fa-square']" @click="toggleFilter('no_category')"></span>
						<label>No Department / Category</label>
					</li>
					<li>
						<span :class="['pointer', 'far', filters.no_image ? 'fa-check-square' : 'fa-square']" @click="toggleFilter('no_image')"></span>
						<label>No Image</label>
					</li>
					<li>
						<span :class="['pointer', 'far', filters.no_manufacturer ? 'fa-check-square' : 'fa-square']" @click="toggleFilter('no_manufacturer')"></span>
						<label>No Manufacturer</label>
					</li>
					<li>
						<span :class="['pointer', 'far', filters.no_caliber ? 'fa-check-square' : 'fa-square']" @click="toggleFilter('no_caliber')"></span>
						<label>No Caliber</label>
					</li>
					<li>
						<span :class="['pointer', 'far', filters.no_product_type ? 'fa-check-square' : 'fa-square']" @click="toggleFilter('no_product_type')"></span>
						<label>No Product Type</label>
					</li>
				</ul>
			</template>

			<template v-if="owner == 'distributor' && (filters.department_id || filters.manufacturer_id)">
				<label>List Only...</label>
				<ul class="checkbox-group">
					<li>
						<span :class="['pointer', 'far', filters.in_stock ? 'fa-check-square' : 'fa-square']" @click="toggleFilter('in_stock')"></span>
						<label>In Stock</label>
					</li>
					<li>
						<span :class="['pointer', 'far', filters.hidden ? 'fa-check-square' : 'fa-square']" @click="toggleFilter('hidden')"></span>
						<label>Hidden / Excluded</label>
					</li>
					<li v-if="getAdministratorFlag">
						<span :class="['pointer', 'far', filters.no_image ? 'fa-check-square' : 'fa-square']" @click="toggleFilter('no_image')"></span>
						<label>No Image</label>
					</li>
					<li v-if="getAdministratorFlag">
						<span :class="['pointer', 'far', filters.no_manufacturer ? 'fa-check-square' : 'fa-square']" @click="toggleFilter('no_manufacturer')"></span>
						<label>No Manufacturer</label>
					</li>
					<li v-if="getAdministratorFlag">
						<span :class="['pointer', 'far', filters.no_caliber ? 'fa-check-square' : 'fa-square']" @click="toggleFilter('no_caliber')"></span>
						<label>No Caliber</label>
					</li>
					<li>
						<span :class="['pointer', 'far', filters.no_product_type ? 'fa-check-square' : 'fa-square']" @click="toggleFilter('no_product_type')"></span>
						<label>No Product Type</label>
					</li>
					<li v-if="getAdministratorFlag">
						<span :class="['pointer', 'far', filters.no_shipping_info ? 'fa-check-square' : 'fa-square']" @click="toggleFilter('no_shipping_info')"></span>
						<label>No Shipping Info</label>
					</li>
				</ul>
			</template>

			<div class="divider"></div>

			<div :class="['button',  hasFilters ? 'neutral' : 'disabled' ]" @click="clearFilters()">Clear Filters</div>
			<div v-if="owner == 'store'" class="button action" @click="addProduct()">Create A Product</div>

			<div class="divider"></div>
			<div v-if="owner == 'store'" :class="['extra-menu-item', { disabled: doExport }]" @click="exportList()">Export List</div>
			<router-link class="extra-menu-item" to="/inventory/merge-products">Find Duplicates</router-link>
			<div v-if="owner == 'store'" class="extra-menu-item" @click="confirmHideStoreProducts()">{{ hideStoreLocation ? 'Unhide' : 'Hide' }} All Store Products</div>

			<div v-if="getDevEnvironment" class="extra-menu-item" @click="getList()">Reload List</div>

			<!-- <div class="extra-menu-item" @click="showGunBrokerConnectionModal = true">GunBroker Connection</div> -->

		</div>

		<div v-if="showDetail" class="filters">

			<div :class="['filter-list-button-large', {'active' : showDetailTab == 'info'}]" @click="fetchDetailTab('info')">Product Info</div>
			<div :class="['filter-list-button-large', productDetail.product_id == 'new' ? 'disabled' : '', showDetailTab == 'availability' ? 'active' : '']" @click="fetchDetailTab('availability')">Inventory</div>
			<div v-if="!getAdministratorFlag" :class="['filter-list-button-large', productDetail.product_id == 'new' ? 'disabled' : '', showDetailTab == 'print_tags' ? 'active' : '']" @click="fetchDetailTab('print_tags')">Print Tags</div>
			<div :class="['filter-list-button-large', productDetail.product_id == 'new' ? 'disabled' : '', showDetailTab == 'specifications' ? 'active' : '']" @click="fetchDetailTab('specifications')">Specifications</div>
			<div :class="['filter-list-button-large', productDetail.product_id == 'new' ? 'disabled' : '', showDetailTab == 'shipping' ? 'active' : '']" @click="fetchDetailTab('shipping')">Shipping & Notices</div>
			<div v-if="!getAdministratorFlag" :class="['filter-list-button-large', productDetail.product_id == 'new' ? 'disabled' : '', showDetailTab == 'sales' ? 'active' : '']" @click="fetchDetailTab('sales')">Sales History</div>
			<div :class="['filter-list-button-large', productDetail.product_id == 'new' ? 'disabled' : '', showDetailTab == 'change_log' ? 'active' : '']" @click="fetchDetailTab('change_log')">Change Log</div>
			<div v-if="gunBrokerEnabled && productDetail.product_id != 'new' && $route.params.owner === 'store'" :class="['filter-list-button-large', productDetail.product_id == 'new' ? 'disabled' : '', showDetailTab == 'gun_broker' ? 'active' : '']" @click="checkGunBrokerCredentials()">GunBroker</div>

			<router-link v-if="!getAdministratorFlag && productDetail.info.in_cart" tag="div" to="/legacy/batchordermaintenance.php" class="button action"><i class="fa fa-shopping-cart"></i> In Your Cart</router-link>
			<div v-else-if="!getAdministratorFlag && productDetail.info.client_id != client_id" :class="['button', addingToCart ? 'adding_to_cart' : 'action']" @click="addToCart(productDetail.info)">Add To Cart</div>

			<a v-if="!getAdministratorFlag && productDetail.product_id != 'new'" class="button neutral" :href="productDetail.info.preview_link" target="_blank">Preview Online</a>

			<div v-if="(getAdministratorFlag || productDetail.info.client_id == client_id) && productDetail.info.inactive == 0" :class="['button', productDetail.info.on_hand > 0 ? 'disabled' : 'delete-large']" @click="confirmDeleteProduct()">Deactivate Product</div>
			<div v-if="(getAdministratorFlag || productDetail.info.client_id == client_id) && productDetail.info.inactive == 1" class="button delete-large" @click="confirmDeleteProduct()">Reactivate Product</div>

			<div v-if="!product_id" class="button neutral" @click="backToList()">Back To List</div>

			<div v-if="returnRoute" class="divider"></div>
			<router-link v-if="returnRoute" :to="returnRoute" class="extra-menu-item">Return to previous program</router-link>

		</div>

		<div v-if="!showDetail" class="list">

			<div v-if="loading" class="empty-list">
				Loading list...
			</div>

			<div v-if="!loading && list.length == 0" class="empty-list">
				<div v-if="owner == 'distributor' && !filters.department_id && !(filters.search_term && noMatchFound)">Select a department or manufacturer<br>to list distributor products</div>
				<div v-else-if="filters.search_term && noMatchFound">No matches for '{{ noMatchFound }}'</div>
				<div v-else>This list is empty</div>
			</div>

		    <table v-else-if="!loading && list.length > 0" class="data-list" cellpadding="0" cellspacing="0">
				<thead>
					<tr>
						<th class="list clickable" width="33" @click="setSortBy('')">
							<div v-if="filters.sort_by != ''" class="one-three-columns align-center no-grid-gap"><i class="fa-solid fa-xmark" style="color: #666;"></i><div style="font-size: 0.7em;">Clear<br>Sort</div></div>
						</th>
						<th class="list left clickable" @click="setSortBy('description')">Product 
							<i v-if="filters.sort_by == 'description'" :class="['fa-solid', filters.sort_order == 'asc' ? 'fa-caret-down' : 'fa-caret-up']"></i>
							<i v-else :class="['fa-solid', 'fa-sort']" style="color: #666;"></i>
						</th>
						<th class="list left clickable" @click="setSortBy('manufacturer')">Manufacturer 
							<i v-if="filters.sort_by == 'manufacturer'" :class="['fa-solid', filters.sort_order == 'asc' ? 'fa-caret-down' : 'fa-caret-up']" @click="toggleFilter('sort_order')"></i>
							<i v-else :class="['fa-solid', 'fa-sort']" style="color: #666;"></i>
						</th>
						<th class="list left clickable" @click="setSortBy('sku')">SKU 
							<i v-if="filters.sort_by == 'sku'" :class="['fa-solid', filters.sort_order == 'asc' ? 'fa-caret-down' : 'fa-caret-up']" @click="toggleFilter('sort_order')"></i>
							<i v-else :class="['fa-solid', 'fa-sort']" style="color: #666;"></i>
						</th>
						<th class="list right clickable" @click="setSortBy('quantity')">Available
							<i v-if="filters.sort_by == 'quantity'" :class="['fa-solid', filters.sort_order == 'asc' ? 'fa-caret-down' : 'fa-caret-up']" @click="toggleFilter('sort_order')"></i>
							<i v-else :class="['fa-solid', 'fa-sort']" style="color: #666;"></i>
						</th>
						<th class="list right">Price</th>
						<th class="list"></th>
					</tr>
				</thead>
				<tbody>
					<tr v-for="item in list" class="clickable-list-item">
						<td class="list tiny-image center" width="33" @click="getDetail(item)"><img :src="item.image_src"></td>
						<td class="list left" @click="getDetail(item)">{{ item.description }}<div class="meta"><label>ID: </label>{{ item.product_id }} <label>UPC: </label>{{ item.upc }}</div></td>
						<td class="list left" @click="getDetail(item)">{{ item.manufacturer }}</td>
						<td class="list left" @click="getDetail(item)">{{ item.sku }}</td>
						<td class="list right" @click="getDetail(item)">{{ owner == 'store' ? item.store_available : item.warehouse_available }}</td>
						<td class="list right" @click="getDetail(item)">{{ $formatCurrency(item.price) }}</td>
						<td v-if="item.client_id != client_id" class="list extra-menu right" @click="addToCart(item)">
							<i :class="['fas fa-shopping-cart', { adding_to_cart: item.adding_to_cart }, { in_cart: item.in_cart }]"></i>
							<div :class="['extra-menu-label', { adding_to_cart: item.adding_to_cart }]">{{ item.in_cart ? 'In Cart' :  (item.adding_to_cart ? 'Adding' : 'Add to Cart') }}</div>
						</td>
						<td v-else class="list extra-menu"></td>
					</tr>
				</tbody>
			</table>

		</div>

		<div v-if="showDetail" class="detail product-detail">

			<loading v-if="loading" class="loading"></loading>

			<div v-if="!loading && showDetailTab == 'info'" class="info-tab">
				<div class="product-info">
					<div>
						<label-required label="UPC" :condition="productDetail.info.upc" />
						<input type="text" v-model="productDetail.info.upc" :readonly="!userCanEdit">
						<label>SKU</label>
						<input type="text" v-model="productDetail.info.sku" :readonly="!userCanEdit">
						<label-required label="Department" :condition="productDetail.info.department_id" />
						<select v-if="userCanEdit" v-model="productDetail.info.department_id" @change="getCategories(productDetail.info.department_id, true)">
							<option value="">Select...</option>
							<option v-for="(department, index) in departments" :value="department.department_id">{{ department.description }}</option>
						</select>
						<input v-else type="text" v-model="productDetail.info.department" readonly="true">
						<label-required label="Category" :condition="productDetail.info.category_id" />
						<select v-if="userCanEdit" v-model="productDetail.info.category_id" :key="productDetail.info.category_id">
							<option value="">Select...</option>
							<option v-for="(category, index) in detailCategories" :value="category.category_id">{{ category.description }}</option>
						</select>
						<input v-else type="text" v-model="productDetail.info.category" readonly="true">
						<label>Caliber</label>
						<div v-if="userCanEdit" class="input-with-control">
							<input type="text" v-model="productDetail.info.caliber" placeholder="Search..." @keyup.enter="getFilterList('caliber', 'info')" @change="getFilterList('caliber', 'info')">
							<div class="button action input-go" @click="getFilterList('caliber', 'info')"><i class="fas fa-search"></i></div>
						</div>
						<input v-else type="text" v-model="productDetail.info.caliber" readonly="true">
						<label>Manufacturer</label>
						<div v-if="userCanEdit" class="input-with-control">
							<input type="text" v-model="productDetail.info.manufacturer" placeholder="Search..." @keyup.enter="getFilterList('manufacturer', 'info')" @change="getFilterList('manufacturer', 'info')">
							<div class="button action input-go" @click="getFilterList('manufacturer', 'info')"><i class="fas fa-search"></i></div>
						</div>
						<input v-else type="text" v-model="productDetail.info.manufacturer" readonly="true">
						<label>Model</label>
						<input type="text" v-model="productDetail.info.model" :readonly="!userCanEdit">
					</div>
					<div>
						<label-required label="Description" :condition="productDetail.info.description" />
						<textarea v-model="productDetail.info.description" :readonly="!userCanEdit" style="height: 4em;"></textarea>
						<label>Detail</label>
						<textarea v-model="productDetail.info.detailed_description" :readonly="!userCanEdit" style="height: 7.5em;"></textarea>
						<div class="two-columns">
							<label>Retail (MSRP)</label>
							<label>MAP</label>
							<input type="text" v-model="productDetail.info.msrp" :readonly="!userCanEdit">
							<div :class="productDetail.info.map ? 'input-with-control' : ''">
								<input type="text" v-model="productDetail.info.map" :readonly="!userCanEdit">
								<div v-if="productDetail.info.map" style="padding: 0.66em;" class="extra-menu" @click="showMapPolicy = true">
									<i class="fa fa-calendar-check" style="cursor: pointer; padding:0.5em;" />
									<div class="extra-menu-label extra-menu-label-right">MAP Holiday</div>
								</div>
							</div>
						</div>
						<label>Product Type</label>
						<!-- hardcoded structure for displaying rental product type to prevent dealers from breaking rentals by changing type -->
						<!-- product_type_id 14 == Rentals -->
						<select v-if="productDetail.info.product_type_id == 14" disabled>
							<option>Rentals</option>
						</select>
						<select v-else v-model="productDetail.info.product_type_id" :disabled="!userCanEdit">
							<option value="">Select...</option>
							<option v-for="(productType, index) in productTypes" :value="productType.product_type_id" :disabled="productType.internal_use_only == 1">{{ productType.description }}</option>
						</select>
						<div class="two-columns" style="margin: 1.25em 0 0 0;">
							<div>
								<checkbox v-model="productDetail.info.serializable" label="Serializable" :disabled="!userCanEdit"/>
							</div>
							<div @click="confirmSetNotTaxable = true">
								<checkbox v-model="productDetail.info.not_taxable" label="Not Taxable" :key="'key_' + productDetail.info.not_taxable"/>
							</div>
						</div>
					</div>
					<div v-if="!getAdministratorFlag" style="grid-column: 1 / span 2;">
						<label>Product Link</label>
						<input type="text" disabled v-model="productDetail.info.preview_link" />
					</div>
					<div class="tab-controls">
						<div :class="['button', 'spaced', userCanEdit && userCanSave && !saving.info ? 'action' : 'disabled']" @click="saveProductInfo('info')">Save Product Info</div>
						<div v-if="!userCanEdit" class="button action spaced" @click="requestProductEdit()">Request Product Edit</div>
						<div v-if="!userCanEdit" class="note"><i class="fas fa-ban"></i> Save product info is disabled for distributor products.</div>
						<div v-if="!userCanSave" class="note"><i class="fas fa-ban"></i> UPC, department, category and description are required.</div>
						<div class="mobile-spacer"></div>
					</div>
				</div>
				<div v-if="productDetail.product_id != 'new'" class="info-tab-image">
					<images-manager
						:images="productDetail.info.product_images"
						:canEdit="true"
						:productId="productDetail.product_id"
						@updateImages="imagesUpdated"
					></images-manager>
				</div>
				<div v-else class="info-tab-image">
			        <div class="button disabled" style="width: 100%">Manage Images</div>
					<div><label>Product images can be added after saving new product info.</label></div>
				</div>
			</div>

			<div v-if="!loading && showDetailTab == 'availability'" class="availability-tab">

				<div class="tab-content" v-if="getAdministratorFlag">
					<label class="checkbox">
						<input type="checkbox" v-model="productDetail.info.internal_use_only" value="1">
						<span><i class="fas fa-check-circle"></i>Hide from Websites</span>
					</label>
					<label class="checkbox">
						<input type="checkbox" v-model="productDetail.info.lock_data" value="1">
						<span><i class="fas fa-check-circle"></i>Lock Descriptions</span>
					</label>
					<label class="checkbox">
						<input type="checkbox" v-model="productDetail.info.lock_map" value="1">
						<span><i class="fas fa-check-circle"></i>Lock MAP</span>
					</label>

					<div :class="['button', 'spaced', saving.info ? 'disabled' : 'action']" @click="saveProductInfo('info')">Save These Settings</div>

				</div>

				<div class="tab-content" v-if="!getAdministratorFlag">
					<div>
						<div class="three-columns">
							<div>
								<div class="tab-section-title">Cost & Price</div>
								<div class="two-columns">
									<label>Your Cost</label><label></label>
									<number-input :decimals='2' :disabled="neverReceived" v-model="productDetail.availability.cost"></number-input>
									<div></div>
									<label>Online Price</label><label></label>
									<number-input :decimals='2' :disabled="neverReceived" v-model="productDetail.availability.web_price"></number-input>
									<div class="meta">
										{{ productDetail.availability.web_profit }}% Profit
										<tool-tip left='-12' content='Profit = (100 * (1 - (cost / price)))'/>
									</div>
									<label>POS Price</label><label></label>
									<number-input :decimals='2' :disabled="neverReceived" v-model="productDetail.availability.price"></number-input>
									<div class="meta">
										{{ productDetail.availability.pos_profit }}% Profit
										<tool-tip left='-12' content='Profit = (100 * (1 - (cost / price)))'/>
									</div>
									
								</div>
								<div class="tab-controls">
									<div :class="['button', 'small', saving.prices || neverReceived ? 'disabled' : 'action']" @click="confirmPriceChange()">Save Prices</div>
									<div v-if="neverReceived" class="note" style="margin: 0.5em 2em 0 0;"><i class="fas fa-ban"></i> Use the Receive Inventory program to set your own cost and prices for this distributor product.</div>
								</div>
							</div>
							<div>
								<div class="tab-section-title">Availability</div>
								<label>On Hand</label>
								<number-input :decimals='0' :disabled="productDetail.availability.serializable || neverReceived" v-model="productDetail.availability.on_hand" :key="'on_hand_' + productDetail.availability.on_hand"></number-input>
								<div class="tab-controls" style="margin: 0 0 2em 0;" v-if="productDetail.availability.serializable && productDetail.availability.serial_numbers.length != productDetail.availability.on_hand">
									<div class="button small action" @click="resyncAvailability()">Resync On Hand</div>
									<div class="note" style="margin: 0.5em 2em 0 0;"><i class="fas fa-exclamation-triangle"></i> On Hand count does not match serial number count.<br />Click the Resync On Hand button to fix.</div>
								</div>
								<div v-if="productDetail.availability.allocated">
									<label>Allocated</label>
									<number-input :decimals='0' v-model="productDetail.availability.allocated"></number-input>
								</div>
								<div class="tab-controls">
									<div :class="['button', 'small', productDetail.availability.serializable || neverReceived ? 'disabled' : 'action']" @click="confirmAvailabilityChange()">Save Availability</div>
									<div v-if="productDetail.availability.serializable || neverReceived" class="note" style="margin: 0.5em 2em 0 0;"><i class="fas fa-ban"></i> Use the Receive Inventory program to add on-hand availability to this {{ neverReceived ? 'distributor' : 'serialized' }} product.</div>
								</div>
								<div class="tab-controls">
									<router-link :to="'/inventory/receive-inventory/?upc=' + productDetail.availability.upc">Receive Inventory...</router-link>
								</div>
							</div>
							<div>
								<div class="tab-section-title">Limits</div>
								<div class="component-with-tool-tip">
									<label class="checkbox">
										<input type="checkbox" v-model="productDetail.availability.excluded" value="1">
										<span><i class="fas fa-check-circle"></i>Hide from Website</span>
									</label>
									<tool-tip left='-12' content='When checked, this item will be hidden from your public website but still available in your POS.'/>
								</div>
								<div class="component-with-tool-tip">
									<label class="checkbox">
										<input type="checkbox" :disabled="productDetail.info.serializable == 1" v-model="productDetail.availability.require_customer" value="1">
										<span :class="{disabled: productDetail.info.serializable == 1}"><i class="fas fa-check-circle"></i>Require POS Customer</span>
									</label>
									<tool-tip left='-12' content='When checked, customer info must be selected to sell this item in your POS.'/>
								</div>
								<div class="component-with-tool-tip">
									<label class="checkbox">
										<input type="checkbox" v-model="productDetail.availability.pickup_only" value="1">
										<span :class="{disabled: productDetail.info.pickup_only == 1}"><i class="fas fa-check-circle"></i>Pickup Only</span>
									</label>
									<tool-tip left='-12' content='When checked, this item will be available for in-store pickup only.'/>
								</div>
								<div v-if="productDetail.info.serializable == 1" class="note" style="margin: -0.66em 0 1em 0;"><i class="fas fa-ban"></i> Serialized items already require a POS Customer.</div>
								<label>Limit Checkout Quantity</label>
								<div class="component-with-tool-tip">
									<number-input :disabled="!usesWebsiteBuilder" :decimals="0" placeholder="Qty..." v-model="productDetail.availability.per_checkout"></number-input>
									<tool-tip left='-12' content='You can specify a maximum quantity per customer during online checkout.'/>
								</div>
								<div v-if="!usesWebsiteBuilder" class="note" style="margin: -0.33em 0 1em 0;"><i class="fas fa-ban"></i> Limit Checkout Quantity is enabled for custom website templates only.</div>
								<div class="tab-controls">
									<div :class="['button', 'small', saving.limits ? 'disabled' : 'action']" @click="confirmLimitsChange()">Save Limits</div>
								</div>
							</div>
						</div>
					</div>
				</div>

				<div class="tab-content" v-if="productDetail.availability.serializable && !getAdministratorFlag">
						<div class="tab-section-title">
							On Hand Serial Numbers
						</div>
							<div v-if="productDetail.availability.serial_numbers.length > 0" class="note">You can remove serial numbers from your available inventory in order to allocate them for other types of sales.<br>Removing serial numbers here will not affect your log books.</div>
							<div v-else class="note">You have no on hand serial numbers for this item.</div>
						<div class="five-columns">
							<div v-for="(serial_number, index) in productDetail.availability.serial_numbers">
								<button class="delete smallest" @click="confirmRemoveSerialNumber(serial_number)"><i class="fa fa-times"></i></button> {{ serial_number }}
							</div>
						</div>
				</div>

				<div class="tab-content" v-if="!getAdministratorFlag">
					<div class="tab-section-title">Price Override</div>

					<div v-if="productDetail.availability.overrides.length > 0" class="list">
					    <table class="data-list" cellpadding="0" cellspacing="0">
							<thead>
								<tr>
									<th class="list left">Customer Type</th>
									<th class="list left">Flag</th>
									<th class="list right">Price</th>
									<th class="list right"></th>
								</tr>
							</thead>
							<tr v-for="(override, index) in productDetail.availability.overrides" class="clickable-list-item" @click="manageOverrides(override)">
								<td class="list left">{{ override.description }}</td>
								<td class="list left">{{ override.display_flag_text }}</td>
								<td class="list right">{{ override.price }}</td>
								<td class="list right">
									<div class="button action" @click="manageOverrides(override)">Edit Override</div>
								</td>
							</tr>
						</table>
					</div>
					<div v-else class="note">
						No override currently set for this product.
						<div class="button action" @click="manageOverrides({ product_id: productDetail.availability.product_id })">Add an Override</div>					
					</div>
				</div>

				<div class="tab-content">
					<div class="tab-section-title">
						Distributor Cost and Availability
					</div>
					<div :class="['distributor-list', { 'distributor-list-admin': getAdministratorFlag }]" v-if="productDetail.availability.distributors.length > 0">
						<label>Distributor</label>
						<label>Item Number</label>
						<label>Cost</label>
						<label>Warehouse</label>
						<label class="right">Available</label>
						<label v-if="getAdministratorFlag" class="right"></label>
						<template v-for="(distributor, index) in productDetail.availability.distributors">
							<span>{{ distributor.company_name }}</span>
							<span>{{ distributor.item_number }}<span v-if="distributor.discontinued" style="margin: 0 0 0 0.5em; font-size: 0.8em; border-top: 0 none;">Discontinued</span></span>
							<span><span v-if="distributor.price">$</span>{{ distributor.price }}</span>
							<span>{{ distributor.location }}</span>
							<span class="right">{{ distributor.quantity }}</span>
							<span v-if="getAdministratorFlag" class="right"><i v-if="distributor.item_number" class="fa fa-random pointer" @click="setSplitItem(distributor)"></i></span>
						</template>
					</div>
					<div v-else class="note">
						No distributor data for this product.
					</div>
				</div>

				<div class="tab-content" v-if="!getAdministratorFlag">
					<div class="tab-section-title">
						Reorder Actions
					</div>
					<div class="note" v-if="productDetail.availability.distributors.length == 0" >
						This item will be placed in the 'Other Supplies' section of the reorder cart for non-distributor products.
					</div>
					<div class="three-columns">
						<div>
							<div class="label">Add {{ productDetail.availability.in_cart ? 'more of ' : ''}}this product to your re-order cart...</div>
							<div class="two-columns">
								<div>
									<input type="number" placeholder="Qty..." v-model="productDetail.availability.add_cart_quantity">
								</div>
								<div>
									<button :class="['button', !addingToCart && productDetail.availability.add_cart_quantity ? 'action' : 'disabled', 'small']" @click="addToCart({product_id: productDetail.availability.product_id, cart_quantity: productDetail.availability.add_cart_quantity})">Add {{ productDetail.availability.in_cart ? 'More ' : 'To Cart'}}</button>
								</div>
							</div>
							<div>{{ addToCartMessage }}</div>
						</div>
						<div>
							<div class="label">Automatically add this product to your re-order cart.</div>
							<div class="two-columns">
								<label>Add to re-order cart...</label>
								<label>When on-hand is...</label>
								<input type="number" placeholder="Qty..." v-model="productDetail.availability.order_quantity">
								<input type="number" placeholder="Qty..." v-model="productDetail.availability.reorder_point">
							</div>
							<div class="tab-controls">
								<button :class="['button', 'small', saving.reorder_actions || !productDetail.availability.hasOwnProperty('order_quantity') || !productDetail.availability.hasOwnProperty('reorder_point') ? 'disabled' : 'action']" @click="confirmSaveReorderActions()">Save Re-order Quantities</button>
								<div v-if="!productDetail.availability.hasOwnProperty('order_quantity') || !productDetail.availability.hasOwnProperty('reorder_point')" class="note"><i class="fas fa-ban"></i> Quantities are required.</div>
								<!-- <message class="message" :block="true" :loading="saving.reorder_actions" :message="saveMessage.reorder_actions"/> -->
							</div>
						</div>
						<div style="margin: 0 0 0 3em;">
							<div class="label">Item status</div>
							<div class="two-one-columns" style="margin: 1em 0 0 0; line-height: 2em;">
								<label>Current On Hand:</label>
								<div class="right">{{ productDetail.availability.on_hand }}</div>
								<label>Total Cost On Hand:</label>
								<div class="right">${{ (productDetail.availability.on_hand * productDetail.availability.cost).toFixed(2) }}</div>
								<label>Last 30 Days Sold:</label>
								<div class="right">{{ productDetail.availability.recent_orders }}</div>
								<label>Current In Your Cart:</label>
								<div class="right">{{ productDetail.info.in_cart }}</div>
							</div>
						</div>
					</div>
				</div>
			</div>

			<div v-if="!loading && showDetailTab == 'print_tags'" class="print-tab">
				<div class="tab-section-title">Print Tags</div>
				<tag-print :productDetail="productDetail" :serialNumbers="productDetail.print_tags.serial_numbers"></tag-print>
			</div>

			<div v-if="!loading && showDetailTab == 'specifications'" class="specifications-tab">
				<div class="tab-section-title">Product Specifications</div>
				<div class="one-two-columns" style="grid-template-columns: 1fr 2fr 3em; margin: 1em;" v-for="(description, index) in productDetail.specifications.descriptions">
					<select v-model="description.product_descriptor_id" :disabled="!userCanEdit" @change="description.content = ''">
						<option v-for="(descriptor, index) in product_descriptors" :value="descriptor.product_descriptor_id">{{ descriptor.description }}</option>
					</select>
					<input type="text" v-model="description.content" :disabled="!description.product_descriptor_id || !userCanEdit">
					<div v-if="userCanEdit" class="button delete-large" style="width: 3.5em;" @click="productDetail.specifications.descriptions.splice(index,1)"><i class="fas fa-times"></i></div>
				</div>
				<div class="two-columns" style="grid-template-columns: 4em 1fr; align-items: start;">
					<div v-if="!userCanEdit || saving.specifications" class="button small disabled" style="width: 4em; margin: 0 0 0 1.25em;"><i class="fas fa-plus"></i></div>
					<div v-else class="button small action" style="width: 3.5em; margin: 0 0 0 1.25em;" @click="productDetail.specifications.descriptions.push({'product_descriptor_id': '', 'content': ''})"><i class="fas fa-plus"></i></div>
					<div class="tab-controls" style="margin: 0;">
						<div :class="['button', 'small', !userCanEdit || saving.specifications ? 'disabled' : 'action']" @click="saveProductInfo('specifications')">Save Specifications</div>
						<div v-if="!userCanEdit" class="note"><i class="fas fa-ban"></i> Save specifications is disabled for distributor products.</div>
						<!-- <message class="message" :block="true" :loading="saving.specifications" :message="saveMessage.specifications"/> -->
					</div>
				</div>
			</div>

			<div v-if="!loading && showDetailTab == 'shipping'" class="shipping-tab">
				<div>
					<div class="tab-section-title">Shipping Info</div>
					<div class="message" style="margin: 1em 0;">Accurate shipping info helps calculate shipping costs.</div>
					<div class="label">Weight</div>
					<number-input :disabled="!userCanEdit" :decimals='2' :inline="true" v-model="productDetail.shipping.ship_weight"/> <span class="label">pounds</span>
					<div class="label">Length</div>
					<number-input :disabled="!userCanEdit" :decimals='2' :inline="true" v-model="productDetail.shipping.ship_length"/> <span class="label">inches</span>
					<div class="label">Width</div>
					<number-input :disabled="!userCanEdit" :decimals='2' :inline="true" v-model="productDetail.shipping.ship_width"/> <span class="label">inches</span>
					<div class="label">Height</div>
					<number-input :disabled="!userCanEdit" :decimals='2' :inline="true" v-model="productDetail.shipping.ship_height"/> <span class="label">inches</span>

					<div style="margin: 1em 0 0 0;">
						<label class="checkbox">
							<input :disabled="!userCanEdit" type="checkbox" v-model="productDetail.shipping.is_hazardous" value="1">
							<span :class="{disabled: !userCanEdit}"><i class="fas fa-check-circle"></i>Classified as hazardous material</span>
						</label>
						<tool-tip left='-11' content="This setting does NOT change checkout hazmat fees, which are only applied for items in the Powder, Primers and Reloading Equipment categories."/>
					</div>

					<div class="tab-controls">
						<div :class="['button', 'small', !userCanEdit || saving.shipping ? 'disabled' : 'action']" @click="saveProductInfo('shipping')">Save Shipping Info</div>
						<div v-if="!userCanEdit" class="note"><i class="fas fa-ban"></i> Save shipping info is disabled for distributor products.</div>
					</div>

				</div>
				<div>
					<div v-if="product_notices_system.length > 0" class="tab-content">
						<div class="tab-section-title">Distributor Product Notices</div>
						<div class="message" style="margin: 1em 0;">Distributor product notices may be specific to your state.</div>
						<div v-for="(notice, index) in product_notices_system">
							<div style="display: inline-block">
								<checkbox v-model="notice.active" :label="notice.description" :disabled="!userCanEdit"/>
							</div>
							<tool-tip left='-11' :content="notice.notice"/>
						</div>
					</div>

					<div>
						<div class="tab-section-title">Custom Product Notices</div>
						<div v-if="product_notices_client.length > 0">
							<div class="message" style="margin: 1em 0;">Checked notices will be displayed on this product's detail page.<tool-tip left='-21' content="Custom product notices are availabile for custom templates only."/></div>
							<div v-for="(notice, index) in product_notices_client">
								<div style="display: inline-block;" @click="saveProductNotice(notice, 'activate')">
									<checkbox v-model="notice.active" :label="notice.description" style="float: left;"/>
								</div>
								<tool-tip left='-11' :content="notice.notice" style="top: -0.5em;"/>
							</div>
						</div>
						<div v-else class="message">You have no custom notices for this product</div>

						<div class="tab-section-titlez" style="margin: 1em 0 1em 0;">Create a new Product Notice</div>
						<input type="text" v-model="newProductNotice.description" placeholder="Description...">
						<textarea v-model="newProductNotice.notice" placeholder="Content..." style="resize: none; height: 4em;"></textarea>
						<div :class="['button', 'small', 'spaced', newProductNotice.description && newProductNotice.notice ? 'action' : 'disabled']" @click="saveProductNotice(newProductNotice, 'new')">Save New Notice</div>
						<router-link tag="button" class="neutral small" to="/legacy/productnoticemaintenance.php">Manage Notices</router-link>

					</div>
				</div>
			</div>

			<div v-if="!loading && showDetailTab == 'sales'" class="sales-tab">
				<div class="tab-content">
					<div>
						<div class="tab-section-title">Sales History</div>
						<div v-if="sales_history.length > 0" class="list">
							<table>
								<tr>
									<th>Number</th>
									<th>Date</th>
									<th>Customer</th>
									<th class="right">Total</th>
								</tr>
								<tr v-for="(sale, index) in sales_history" class="clickable-list-item" @click="goToOrder(sale)">
									<td>{{ sale.order_number }}</td>
									<td>{{ sale.order_date }}</td>
									<td>{{ sale.customer }}</td>
									<td class="right">{{ sale.order_total }}</td>
								</tr>
							</table>
							<div class="sub-header bottom" v-if="productDetail.sales.total_pages > 1">
								<div></div>
								<div class="controls">
									<pagination v-if="!loading" :paging="productDetail.sales" @updatePage="goToSalesHistoryPage"></pagination>
								</div>
							</div>
						</div>
						<div v-else class="empty-list">No sales history for this product</div>
					</div>
					<div>
						<div class="tab-section-title">Sales Totals</div>
						<div class="two-one-columns" style="margin: 1em 0 0 0; line-height: 2em;">
							<label>Total Sold:</label>
							<div class="right">{{ productDetail.sales.total_quantity }}</div>
							<label>Total Cost:</label>
							<div class="right">{{ productDetail.sales.total_cost }}</div>
							<label>Total Price:</label>
							<div class="right">{{ productDetail.sales.total_price }}</div>
							<label>Total Profit:</label>
							<div class="right">{{ productDetail.sales.total_profit }}</div>
							<label>Total Margin:</label>
							<div class="right">{{ productDetail.sales.total_margin }}</div>
						</div>
					</div>
				</div>
			</div>

			<div v-if="!loading && showDetailTab == 'change_log'" class="change_log-tab">
				<div class="tab-content">
					<div class="tab-section-title">Change Log</div>
					<div v-if="change_log.length > 0" class="list">
						<table>
							<tr>
								<th>Date / Time</th>
								<th>User</th>
								<th>Type</th>
								<th>Event</th>
								<th>Reason</th>
							</tr>
							<tr v-for="(log, index) in change_log" class="clickable-list-item" @click="getChangeLogDetail(log)">
								<td>{{ log.log_time }}</td>
								<td>{{ log.user_name }}</td>
								<td>{{ log.type }}</td>
								<td>{{ log.program_code }}</td>
								<td>{{ log.description }}</td>
							</tr>
						</table>
						<div class="sub-header bottom" v-if="productDetail.sales.total_pages > 1">
							<div></div>
							<div class="controls">
								<pagination :paging="productDetail.change_log" @updatePage="goToChangeLogPage"></pagination>
							</div>
						</div>
					</div>
					<div v-else class="empty-list">No change log records for this product</div>
				</div>
			</div>

			<!-- Start Gunbroker Tab -->
			<div v-if="!loading && showDetailTab == 'gun_broker'" class="gun-broker-tab info-tab">
				<template v-if="gunBrokerItemNotes.length">
					<div v-for="(note, index) in gunBrokerItemNotes" :class="['note', 'span-two', note.color]" :key="index">
						<i :class="note.icon"></i>
						<div>
							<div v-html="note.message"></div>
							<a v-if="note.link" style="margin-left: 0.5em;" :href="note.link.url" target="_blank">{{ note.link.text }}</a>
						</div>
					</div>
				</template>
				
				<h2>Allocation</h2>
				<div class="one-two-columns span-two" style="margin-bottom: 1em;">
                    <div>
                        <label>
                            <input type="radio" v-model="gunBrokerAllocateProduct" :value="true" :disabled="this.productDetail.availability.on_hand < 1">
                            <span>Allocate</span>
                        </label>
                        <div style="padding: 0 0 0 1.25em;">
                            <div>
                                <label-required label="Quantity to Allocate: " :condition="gunBrokerAllocateProduct ? gunBrokerQuantityToAllocate > 0 : true" />
                                <input type="number" v-model.number="gunBrokerQuantityToAllocate" :disabled="!gunBrokerAllocateProduct" min="1" :max="productDetail.availability.on_hand" style="width: 3em;" @blur="validateGunBrokerQuantityToAllocate">
                            </div>
                            <button v-if="gunBrokerItemDetail.ItemID" class="button small action" @click="updateGunBrokerProductAllocation" style="align-self: flex-end;">Update</button>
                        </div>
                        <label>
                            <input type="radio" v-model="gunBrokerAllocateProduct" :value="false" :disabled="this.productDetail.availability.on_hand < 1">
                            <span>Do Not Allocate</span>
                        </label>
                    </div>
                    <div>
                        <p>Allocating inventory for GunBroker removes it from your Flight Deck sellable inventory until the listing expires.</p>
                        <p><b>If you do not allocate, you risk overselling your inventory.</b></p>
                    </div>
				</div>

				<template v-if="!gunBrokerItemDetail.ItemID && templates.length > 0">
					<h2>GunBroker Templates</h2>
					<label>You can select a template to pre-populate most settings...</label>
					<div class="templates">
						<div v-for="(template, templateId) in templateMap" :class="['template-option', { selected: templateId == selectedTemplateId }]" :key="templateId"><span @click="selectTemplate(templateId)">{{ template.Name }}</span> <i class="fa fa-trash" aria-hidden="true" @click="deleteTemplate(templateId)"></i></div>					
					</div>
				</template>

				<h2>GunBroker Item Details <tool-tip content="Changing GunBroker Item Details will not change your CDS item details." /></h2>
				<div class="span-two" style="margin-bottom: 1em;">
					<label-required label="Title (Max 75 characters)" :condition="gunBrokerItemDetail.Title" />
					<textarea v-model="gunBrokerItemDetail.Title" style="height: 4em;" maxlength="75" :disabled="!canEditGunBrokerItem"></textarea>
					<label-required label="Description" :condition="gunBrokerItemDetail.Description" />
					<gun-broker-description-field :value="gunBrokerItemDetail.Description" :disabled="!canEditGunBrokerItem" @input="gunBrokerItemDetail.Description = $event" />
				</div>
				<div>
					<label>UPC <tool-tip content="Only enter a valid industry UPC to sync to GunBroker. If you have created a custom UPC for this item, leave this field blank." /></label>
					<input type="text" v-model="gunBrokerItemDetail.UPC" :disabled="!canEditGunBrokerItem">
					<label>SKU</label>
					<input type="text" v-model="gunBrokerItemDetail.SKU" :disabled="!canEditGunBrokerItem">
					<label>Manufacturer Part Number</label>
					<input type="text" v-model="gunBrokerItemDetail.MfgPartNumber" :disabled="!canEditGunBrokerItem">
					<template v-if="!gunBrokerItemDetail.CategoryID">
						<div v-for="(gunBrokerCategory, index) in gunBrokerCategories" :key="index">
							<label-required :label="`GunBroker ${ index > 0 ? 'Sub-' : ''}Category` + (gunBrokerItemDetail.ItemID ? ' (locked)' : '')" :condition="gunBrokerCategoryID" />
							<select v-if="gunBrokerCategories.length" v-model="selectedGunBrokerCategories[index]" @change="fetchGunBrokerCategories(selectedGunBrokerCategories[index], index + 1)" :key="gunBrokerCategory.categoryID" :disabled="!canEditGunBrokerItem">
								<option :value="{}" selected>Select...</option>
								<option v-for="category in gunBrokerCategory" :value="category">{{ category.categoryName }}</option>
							</select>
						</div>
						<div v-if="loadingGunBrokerCategories" style="margin: 1em 0;">Loading categories...</div>
					</template>
					<template v-else>
						<label>GunBroker Category <span v-if="gunBrokerItemDetail.ItemID">(locked)</span></label>
						<div class="category-display">
							<input type="text" class="disabled" v-model="gunBrokerItemDetail.CategoryName" readonly>
							<div v-if="!gunBrokerItemDetail.ItemID && canEditGunBrokerItem" class="change-gb-category" @click="gunBrokerItemDetail.CategoryID = null">Change Category</div>
						</div>
					</template>
					<label-required :label="'Condition' + (gunBrokerItemDetail.ItemID ? ' (locked)' : '')" :condition="gunBrokerItemDetail.Condition" />
					<select v-model="gunBrokerItemDetail.Condition" :disabled="gunBrokerItemDetail.ItemID || !canEditGunBrokerItem">
						<option :value="null">Select...</option>
						<option v-for="item in gunBrokerCondition" :value="item.id">{{ item.label }}</option>
					</select>
					<template v-if="gunBrokerItemDetail.SerialNumber">
						<label>Serial Number</label>
						<input class="disabled" type="text" v-model="gunBrokerItemDetail.SerialNumber" readonly>
					</template>
				</div>
				<div>
					<div class="two-columns" style="margin: 1.25em 0;">
						<div>
							<checkbox v-model="gunBrokerItemDetail.IsFFLRequired" :label="'FFL Required' + (gunBrokerItemDetail.ItemID ? ' (locked)' : '')" :disabled="gunBrokerItemDetail.ItemID || gunBrokerItemDetail.SerialNumber || !canEditGunBrokerItem" />
						</div>
						<div>
							<checkbox v-model="gunBrokerItemDetail.CollectTaxes" :label="'Collect Taxes' + (gunBrokerItemDetail.ItemID ? ' (locked)' : '')" :disabled="gunBrokerItemDetail.ItemID || !canEditGunBrokerItem" />
						</div>
					</div>
					<label>California Prop 65 Text</label>
					<textarea v-model="gunBrokerItemDetail.Prop65Warning" style="height: 4em;" :disabled="!canEditGunBrokerItem"></textarea>
					<label>Additional Terms of Sale</label>
					<select v-model="gunBrokerItemDetail.StandardTextID" :disabled="!canEditGunBrokerItem">
						<option :value="null">None Selected</option>
						<option v-for="item in gunBrokerStandardTextList" :value="item.objectID">{{ item.nickname }}</option>
					</select>
					<label v-if="selectedStandardText">Terms of Sale Text (must be edited directly on GunBroker)</label>
					<div v-if="selectedStandardText" v-html="selectedStandardText.text" style="border: 1px solid #D1D1D1; padding: 0.5em; height: 4.5em; overflow-y: auto" :disabled="!canEditGunBrokerItem"></div>
				</div>
				<div class="info-tab-image">
					<images-manager
						:images="gunBrokerPictureURLs"
						:canEdit="canEditGunBrokerItem && !gunBrokerItemDetail.ItemID"
						:productId="productDetail.product_id"
						:isGBItem="true"
						@updateImages="imagesUpdated"
						@reSyncProductImages="gunBrokerPictureURLs = productDetail.info.product_images"
					></images-manager>
				</div>
				
				<h2 style="margin-top: 1.5em;">Listing Options</h2>
				<div v-if="!gunBrokerItemDetail.ItemID" class="three-columns span-two" style="margin-bottom: 1em;">
					<label>
						<input type="radio" v-model="gbListingType" value="Standard Auction" @change="resetGunBrokerListingOptions">
						<span>Standard Auction</span>
					</label>
					<label>
						<input type="radio" v-model="gbListingType" value="Short-Term Auction" @change="resetGunBrokerListingOptions">
						<span>Short-Term Auction</span>
					</label>
					<label>
						<input type="radio" v-model="gbListingType" value="Fixed Price" @change="resetGunBrokerListingOptions">
						<span>Fixed Price</span>
					</label>
				</div>
				<div v-else class="span-two" style="margin: 0.5em 0 1em 0; padding-bottom: 0.4em; border-bottom: 2px solid lightgrey; font-weight: bold;">{{ gbListingTypeLabel }}</div>

				<template v-if="gbListingType === 'Standard Auction'">
					<div>
						<label-required label="Starting Bid" :condition="gunBrokerItemDetail.StartingBid" />
						<number-input :decimals='2' v-model.number="gunBrokerItemDetail.StartingBid" :disabled="!canEditGunBrokerItem" />
						<label>Reserve Price (2% Charge)</label>
						<number-input :decimals='2' v-model="gunBrokerItemDetail.ReservePrice" :disabled="!canEditGunBrokerItem" />
						<div v-if="gunBrokerItemDetail.ReservePrice !== null && gunBrokerItemDetail.ReservePrice !== '' && gunBrokerItemDetail.StartingBid >= gunBrokerItemDetail.ReservePrice" class="error" style="margin-bottom: 0.5em; margin-top: -0.5em; font-size: 0.9em;">Reserve price must be greater than starting bid {{ gunBrokerItemDetail.ReservePrice === '' }}</div>
					</div>
					<div>
						<label>Buy Now Price</label>
						<number-input :decimals='2' v-model.number="gunBrokerItemDetail.BuyNowPrice" :disabled="!canEditGunBrokerItem" />
						<div v-if="gunBrokerItemDetail.BuyNowPrice !== null && gunBrokerItemDetail.BuyNowPrice !== '' && gunBrokerItemDetail.StartingBid > gunBrokerItemDetail.BuyNowPrice" class="error" style="margin-bottom: 0.5em; margin-top: -0.5em; font-size: 0.9em;">Buy now price must be greater than or equal to starting bid</div>
						<label-required :label="'Listing Duration' + (gunBrokerItemDetail.ItemID ? ' (locked)' : '')" :condition="gunBrokerItemDetail.ListingDuration" />
						<select v-model="gunBrokerItemDetail.ListingDuration" :disabled="gunBrokerItemDetail.ItemID">
							<option :value="null">Select...</option>
							<option v-for="duration in gunBrokerListingDuration[gbListingType]" :value="duration.id">{{ duration.id }} day<template v-if="duration.id !== 1">s</template></option>
						</select>
					</div>
					<div class="span-two" style="margin-bottom: 1em;">
						<label style="margin-right: 1em;">
							<input type="radio" v-model="gunBrokerItemDetail.AutoRelist" :value="1" :disabled="gunBrokerItemDetail.ItemID">
							<span>No auto relist</span>
						</label>
						<label style="margin-right: 1em;">
							<input type="radio" v-model="gunBrokerItemDetail.AutoRelist" :value="2" :disabled="gunBrokerItemDetail.ItemID">
							<span>Relist until item is sold or up to 90 days</span>
						</label>
						<label>
							<input type="radio" v-model="gunBrokerItemDetail.AutoRelist" :value="3" :disabled="gunBrokerItemDetail.ItemID">
							<span>Relist even if sold or up to 90 days</span>
						</label>
						<div style="width: 45%; margin-top: 0.5em;" v-if="gunBrokerItemDetail.AutoRelist === 3">
							<label-required label="How many times?" :condition="gunBrokerItemDetail.AutoRelist === 3 && gunBrokerItemDetail.AutoRelistFixedCount" />
							<input type="number" v-model="gunBrokerItemDetail.AutoRelistFixedCount" min="1" :max="productDetail.availability.on_hand" :disabled="gunBrokerItemDetail.ItemID" @blur="validateGunBrokerAutoRelistFixedCount">
						</div>
					</div>
					<template v-if="gunBrokerItemDetail.Bids > 0">
						<div class="span-two" style="margin: 0.5em 0 1em 0; padding-bottom: 0.4em; border-bottom: 2px solid lightgrey; font-weight: bold;">Bidding Information</div>
						<div>
							<div>Number of Bids: {{ gunBrokerItemDetail.Bids }}</div>
							<div>Current Bid: ${{ gunBrokerItemDetail.CurrentBid }}</div>
							<div>Has Winning Bid: {{ gunBrokerItemDetail.HasWinningBid ? 'Yes' : 'No' }}</div>
						</div>
					</template>
				</template>

				<template v-if="gbListingType === 'Short-Term Auction'">
					<div class="span-two" style="margin-bottom: 1em;">
						<i class="fas fa-exclamation-triangle"></i>  There is a $0.50 insertion fee for using this type of listing.
					</div>
					<div>
						<label-required label="Starting Bid" :condition="gunBrokerItemDetail.StartingBid" />
						<number-input :decimals='2' v-model.number="gunBrokerItemDetail.StartingBid" :disabled="!canEditGunBrokerItem" />
					</div>
					<div>
						<label>Buy Now Price</label>
						<number-input :decimals='2' v-model.number="gunBrokerItemDetail.BuyNowPrice" :disabled="!canEditGunBrokerItem" />
						<div v-if="gunBrokerItemDetail.BuyNowPrice !== null && gunBrokerItemDetail.BuyNowPrice !== '' && gunBrokerItemDetail.StartingBid > gunBrokerItemDetail.BuyNowPrice" class="error" style="margin-bottom: 0.5em; margin-top: -0.5em; font-size: 0.9em;">Buy now price must be greater than or equal to starting bid</div>
						<label-required label="Listing Duration" :condition="gunBrokerItemDetail.ListingDuration" />
						<select v-model="gunBrokerItemDetail.ListingDuration" :disabled="gunBrokerItemDetail.ItemID">
							<option ::value="null">Select...</option>
							<option v-for="duration in gunBrokerListingDuration[gbListingType]" :value="duration.id">{{ duration.id }} day<template v-if="duration.id !== 1">s</template></option>
						</select>
					</div>
					<div class="span-two" style="margin-bottom: 1em;">
						<label style="margin-right: 1em;">
							<input type="radio" v-model="gunBrokerItemDetail.AutoRelist" :value="1" :disabled="gunBrokerItemDetail.ItemID">
							<span>No auto relist</span>
						</label>
						<label style="margin-right: 1em;">
							<input type="radio" v-model="gunBrokerItemDetail.AutoRelist" :value="2" :disabled="gunBrokerItemDetail.ItemID">
							<span>Relist until item is sold or up to 12 days</span>
						</label>
						<label>
							<input type="radio" v-model="gunBrokerItemDetail.AutoRelist" :value="3" :disabled="gunBrokerItemDetail.ItemID">
							<span>Relist even if sold or up to 12 days</span>
						</label>
					</div>
					<div style="width: 45%;" v-if="gunBrokerItemDetail.AutoRelist === 3">
						<label-required label="How many times?" :condition="gunBrokerItemDetail.AutoRelist === 3 && gunBrokerItemDetail.AutoRelistFixedCount" />
						<input type="number" v-model="gunBrokerItemDetail.AutoRelistFixedCount" min="1" :disabled="gunBrokerItemDetail.ItemID">
					</div>
					<template v-if="gunBrokerItemDetail.Bids > 0">
						<div class="span-two" style="margin: 0.5em 0 1em 0; padding-bottom: 0.4em; border-bottom: 2px solid lightgrey; font-weight: bold;">Bidding Information</div>
						<div>
							<div>Number of Bids: {{ gunBrokerItemDetail.Bids }}</div>
							<div>Current Bid: ${{ gunBrokerItemDetail.CurrentBid }}</div>
							<div>Has Winning Bid: {{ gunBrokerItemDetail.HasWinningBid ? 'Yes' : 'No' }}</div>
						</div>
					</template>
				</template>

				<template v-if="gbListingType === 'Fixed Price'">
					<div>
						<label-required label="Fixed Price" :condition="gunBrokerItemDetail.FixedPrice" />
						<number-input :decimals='2' v-model="gunBrokerItemDetail.FixedPrice" :disabled="!canEditGunBrokerItem" />
						<label-required label="Quantity" :condition="gunBrokerItemDetail.Quantity > 0" />
						<input type="number" v-model="gunBrokerItemDetail.Quantity" min="1" :disabled="!canEditGunBrokerItem">
						<ul class="checkbox-group">
							<li>
								<span v-if="canEditGunBrokerItem" :class="['pointer', 'far', gunBrokerItemDetail.CanOffer ? 'fa-check-square' : 'fa-square']"  @click="gunBrokerItemDetail.CanOffer = !gunBrokerItemDetail.CanOffer"></span>
								<span v-else :class="['far', gunBrokerItemDetail.CanOffer ? 'fa-check-square' : 'fa-square']"></span>
								<label>Accept Offers</label>
							</li>
						</ul>
						<div v-if="gunBrokerItemDetail.CanOffer" class="two-columns" style="margin: 1.25em 0 0 0;">
							<label-required label="Auto Accept Price" :condition="gunBrokerItemDetail.AutoAcceptPrice" />
							<label-required label="Auto Reject Price" :condition="gunBrokerItemDetail.AutoRejectPrice" />
							<number-input :decimals='2' v-model="gunBrokerItemDetail.AutoAcceptPrice" />
							<number-input :decimals='2' v-model="gunBrokerItemDetail.AutoRejectPrice" />
						</div>
					</div>
					<div>
						<label-required label="Listing Duration" :condition="gunBrokerItemDetail.ListingDuration" />
						<select v-model="gunBrokerItemDetail.ListingDuration">
							<option :value="null">Select...</option>
							<option v-for="duration in gunBrokerListingDuration[gbListingType]" :value="duration.id">{{ duration.id }} day<template v-if="duration.id !== 1">s</template></option>
						</select>
						<ul class="checkbox-group">
							<li>
								<span v-if="canEditGunBrokerItem" :class="['pointer', 'far', gunBrokerItemDetail.AutoRelist === 4 ? 'fa-check-square' : 'fa-square']"  @click="handleClickAutoRelist"></span>
								<span v-else :class="['far', gunBrokerItemDetail.AutoRelist === 4 ? 'fa-check-square' : 'fa-square']"></span>
								<label>Relist the item automatically?</label>
							</li>
						</ul>
					</div>
				</template>

				<h2 style="margin-top: 1.5em;">Premium Features <tool-tip content="If you use these features, they will incur an extra charge." /></h2>
				<div class="flex column gap-1">
					<div class="flex column gap-0.5">
						<checkbox v-model="gunBrokerItemDetailMeta.SubTitle" :label="'Item Subtitle ($3.50)' + (gunBrokerItemDetail.ItemID ? ' (locked)' : '')" :disabled="gunBrokerItemDetail.ItemID" />
						<input v-if="gunBrokerItemDetailMeta.SubTitle && !gunBrokerItemDetail.ItemID" type="text" v-model="gunBrokerItemDetail.PremiumFeatures.SubTitle" maxlength="50">
						<input v-else-if="gunBrokerItemDetail.ItemID && gunBrokerItemDetailMeta.SubTitle" type="text" v-model="gunBrokerItemDetail.SubTitle" :disabled="!canEditGunBrokerItem" maxlength="50">
					</div>
					<div class="flex column gap-0.5">
						<checkbox v-model="gunBrokerItemDetail.PremiumFeatures.IsShowCaseItem" label="Showcase my listing ($4.95)" :disabled="gunBrokerItemDetail.ItemID" />
						<div class="small">Your listing is shown on the homepage.</div>
					</div>
					<div class="flex column gap-0.5">
						<checkbox v-model="gunBrokerItemDetail.PremiumFeatures.IsFeaturedItem" label="Feature my listing ($2.95)" :disabled="gunBrokerItemDetail.ItemID" />
						<div class="small">Your listing is shown before non-featured items on the search results page.</div>
					</div>
				</div>
				
				<div class="flex column gap-1">
					<checkbox v-model="gunBrokerItemDetailMeta.TitleColor" :label="'Title Color ($1.00)' + (gunBrokerItemDetail.ItemID ? ' (locked)' : '')" :disabled="gunBrokerItemDetail.ItemID" />
					<select v-if="gunBrokerItemDetailMeta.TitleColor && !gunBrokerItemDetail.ItemID" v-model="gunBrokerItemDetail.PremiumFeatures.TitleColor" :disabled="gunBrokerItemDetail.ItemID">
						<option :value="null">None</option>
						<option value="Red">Red</option>
						<option value="Green">Green</option>
						<option value="Blue">Blue</option>
					</select>

					<checkbox v-model="gunBrokerItemDetailMeta.ScheduleStartingDate" :label="'Schedule Listing ($0.10)' + (gunBrokerItemDetail.ItemID ? ' (locked)' : '')" :disabled="!!gunBrokerItemDetail.ItemID" />
					<date-time-input v-if="gunBrokerItemDetailMeta.ScheduleStartingDate" v-model="gunBrokerScheduledStartingDate" :disabled="!!gunBrokerItemDetail.ItemID" style="width: 100%;" />
					<div v-if="scheduledStartingDateError" class="error">Date may not be in the past.</div>
				</div>

				<h2 style="margin-top: 1.5em;">GunBroker Shipping and Payment Methods</h2>
				<div>
					<label-required :label="'Who Pays for Shipping' + (gunBrokerItemDetail.ItemID ? ' (locked)' : '')" :condition="gunBrokerItemDetail.WhoPaysForShipping" />
					<select v-model="gunBrokerItemDetail.WhoPaysForShipping" :disabled="gunBrokerItemDetail.ItemID || !canEditGunBrokerItem">
						<option :value="null">Select...</option>
						<option v-for="item in gunBrokerWhoPaysForShipping" :value="item.id">{{ item.label }}</option>
					</select>
					<label-required :label="'Supported Shipping Classes' + (gunBrokerItemDetail.ItemID ? ' (locked)' : '')" :condition="validateShippingClasses" />
					<ul class="checkbox-group">
						<li v-for="shippingClass in gunBrokerShippingClassesSupported">
							<span v-if="!gunBrokerItemDetail.ItemID && canEditGunBrokerItem" :class="['pointer', 'far', gunBrokerItemDetail.ShippingClassesSupported[shippingClass.id] ? 'fa-check-square' : 'fa-square']"  @click="toggleShippingClass(shippingClass.id)"></span>
							<span v-else :class="['far', gunBrokerItemDetail.ShippingClassesSupported[shippingClass.id] ? 'fa-check-square' : 'fa-square']"></span>
							<label>{{ shippingClass.label }}</label>
							<span class="shipping-class-cost-input" v-if="gunBrokerItemDetail.ShippingClassesSupported[shippingClass.id]">
								<label>Cost (enter zero for no cost):</label><number-input :decimals='2' v-model="gunBrokerItemDetail.ShippingClassCosts[shippingClass.id]" :disabled="!canEditGunBrokerItem || gunBrokerItemDetail.ItemID" />
							</span>
						</li>
					</ul>
					<ul class="checkbox-group">
						<li>
							<span v-if="!gunBrokerItemDetail.ItemID && canEditGunBrokerItem" :class="['pointer', 'far', gunBrokerItemDetail.WillShipInternational ? 'fa-check-square' : 'fa-square']"  @click="gunBrokerItemDetail.WillShipInternational = !gunBrokerItemDetail.WillShipInternational"></span>
							<span v-else :class="['far', gunBrokerItemDetail.WillShipInternational ? 'fa-check-square' : 'fa-square']"></span>
							<label>Will Ship Internationally <span v-if="gunBrokerItemDetail.ItemID">(locked)</span></label>
						</li>
					</ul>
					<div class="one-two-columns" style="margin: 0 0 0.5em 0;">
						<div>
							<label>Weight <span v-if="gunBrokerItemDetail.ItemID">(locked)</span></label><br>
							<input type="number" v-model="gunBrokerItemDetail.Weight" :disabled="gunBrokerItemDetail.ItemID" style="width: 5em;">
						</div>
						<div>
							<div style="margin-top: 1.25em;">
								<label>
									<input type="radio" v-model="gunBrokerItemDetail.WeightUnit" :value="1" :disabled="gunBrokerItemDetail.ItemID ||!canEditGunBrokerItem">
									<span>Pounds (lbs)</span>
								</label>
							</div>
							<label>
								<input type="radio" v-model="gunBrokerItemDetail.WeightUnit" :value="2" :disabled="gunBrokerItemDetail.ItemID ||!canEditGunBrokerItem">
								<span>Kilograms (kg)</span>
							</label>
						</div>
					</div>
					<label>State Exclusions <span v-if="gunBrokerItemDetail.ItemID">(locked)</span></label>
					<select v-model="gunBrokerItemDetailMeta.ExcludeStates" :disabled="gunBrokerItemDetail.ItemID || !canEditGunBrokerItem">
						<option :value="false">I want to sell my item to all states</option>
						<option :value="true">I do not want to sell my item to the following states</option>
					</select>

					<template v-if="gunBrokerItemDetailMeta.ExcludeStates === true">
						<state-select v-if="!gunBrokerItemDetail.ItemID" :selectedState="gunBrokerSelectedState" :disabled="!!gunBrokerItemDetail.ItemID" :showApo="true" :showTerritories="true" :exclusionList="gunBrokerExcludedStates || []" @updateSelected="addGunBrokerExcludedState" />
						<!-- <div v-if="!gunBrokerSelectedState">
							<button class="button small cancel spaced" @click="gunBrokerSelectedState = null">Cancel</button>
							<button class="button small action spaced" @click="addGunBrokerExcludedState"><i class="fa fa-plus" /> Add</button>
						</div> -->
						<template v-if="gunBrokerExcludedStates && gunBrokerExcludedStates.length > 0">
							<label>Excluded States</label>
							<ul class="excluded-states-list flex wrap align-start">
								<li v-for="(state, index) in gunBrokerExcludedStates" :key="state">
									{{ state }}
									<i v-if="!gunBrokerItemDetail.ItemID" class="fa fa-times pointer" aria-hidden="true" @click="removeGunBrokerExcludedState(index)"></i>
								</li>
							</ul>
						</template>
					</template>
				</div>
				<div>
					<label-required :label="'Payment Methods' + (gunBrokerItemDetail.ItemID ? ' (locked)' : '')" :condition="validatePaymentMethods" />
					<ul class="checkbox-group">
						<li v-for="paymentMethod in gunBrokerPaymentMethods" :class="{ 'clickable': canEditGunBrokerItem }">
							<span v-if="!gunBrokerItemDetail.ItemID && canEditGunBrokerItem" :class="['pointer', 'far', gunBrokerItemDetail.PaymentMethods[paymentMethod.id] ? 'fa-check-square' : 'fa-square']"  @click="togglePaymentMethod(paymentMethod.id)"></span>
							<span v-else :class="['far', gunBrokerItemDetail.PaymentMethods[paymentMethod.id] ? 'fa-check-square' : 'fa-square']"></span>
							<label>{{ paymentMethod.label }}</label>
						</li>
					</ul>
					<ul class="checkbox-group">
						<li>
							<span v-if="!gunBrokerItemDetail.ItemID && canEditGunBrokerItem" :class="['pointer', 'far', gunBrokerItemDetail.PaymentPlan ? 'fa-check-square' : 'fa-square']"  @click="gunBrokerItemDetail.PaymentPlan = !gunBrokerItemDetail.PaymentPlan"></span>
							<span v-else :class="['far', gunBrokerItemDetail.PaymentPlan ? 'fa-check-square' : 'fa-square']"></span>
							<label>Layaway Available</label>
						</li>
					</ul>

					<label-required :label="'Zip Code' + (gunBrokerItemDetail.ItemID ? ' (locked)' : '')" :condition="gunBrokerItemDetail.PostalCode" />
					<input type="text" v-model="gunBrokerItemDetail.PostalCode" placeholder="Zip Code" :disabled="gunBrokerItemDetail.ItemID || !canEditGunBrokerItem" />

					<label>Inspection Period <span v-if="gunBrokerItemDetail.ItemID">(locked)</span></label>
					<select v-model="gunBrokerItemDetail.InspectionPeriod" :disabled="gunBrokerItemDetail.ItemID || !canEditGunBrokerItem">
						<option :value="null">Select Inspection Period...</option>
						<option v-for="item in gunBrokerInspectionPeriods" :value="item.id">{{ item.label }}</option>
					</select>
				</div>

				<div v-if="this.productDetail.availability.on_hand > 0" class="tab-controls" style="margin-top: 1.5em;">
					<div class="two-columns">
						<div>
							<div v-if="!gunBrokerItemDetail.ItemID" :class="['button', 'spaced', 'action']" @click="listGBItem()">List Item on GunBroker</div>
							<div v-else-if="gunBrokerItemHasSold || gunBrokerItemHasEnded" :class="['button', 'spaced', 'action']" @click="resetGunBrokerItem(true)">
								Relist Item on GunBroker
								<tool-tip content="You will have a chance to edit the item first before relisting" />
							</div>
							<div v-else :class="['button', 'small', 'spaced', canEditGunBrokerItem && getGunBrokerItemDetailChangedItems ? 'action' : 'disabled']" @click="updateGBItem()">Update Item on GunBroker</div>
							<div v-if="gunBrokerItemDetail.ItemID && !gunBrokerItemDetail.Bids && !gunBrokerItemHasSold && !gunBrokerItemHasEnded" :class="['button', 'small', 'spaced', 'action']" @click="confirmEndGBItem = true">End Item Early</div>
						</div>
						<div v-if="gunBrokerItemDetail.ItemID" class="clickable" @click="savingTemplate = true">Save these settings as a template?</div>
					</div>
					<div class="mobile-spacer"></div>
				</div>

				<template v-if="gunBrokerItemDetail.ItemID">
					<h2 style="margin-top: 1.5em;">Listed GunBroker Item Info</h2>
					<div>
						<label>GunBroker Item ID</label>
						<div style="font-size: 1.5em; margin: 0.5em 0 0 0;">{{ gunBrokerItemDetail.ItemID }}</div>
					</div>
					<div>
						<label>GunBroker Item Link</label>
						<div style="font-size: 1em; margin: 1em 0 0 0;"><a :href="gunBrokerItemLink" target="_blank" v-if="gunBrokerItemLink">{{ gunBrokerItemLink }}</a></div>
					</div>
				</template>
				
			</div>

		</div>

	</div>

	<div class="modal" v-if="savingTemplate">
		<div class="inner">
			<h2>Save Settings As Template</h2>
			<div class="content">
				Most settings can be saved as a template to pre-populate new listings...
				<div class="three-columns align-items-start" style="grid-template-columns: 1fr 1.5fr 1.5fr; margin: 1em 0;">
					<div>
						<b>Item Details...</b><br>
						Condition<br>
						FFL Required<br>
						Collect Taxes<br>
						California Prop 65 Text<br>
						Additional Terms of Sale
					</div>
					<div>
						<b>Listing Options...</b><br>
						No auto relist<br>
						Relist until item is sold or up to 90 days<br>
						Relist even if sold or up to 90 days
					</div>
					<div>
						<b>Shipping and Payment Methods...</b><br>
						Who Pays for Shipping<br>
						Supported Shipping Classes<br>
						State Exclusions<br>
						Payment Methods<br>
						Zip Code
					</div>
				</div>
				<div class="two-columns align-items-start">
					<div>
						<label>Select an existing template to update...</label>
						<div v-if="templates.length > 0">
							<select v-model="selectedTemplateId">
								<option :value="null">Select...</option>
								<option v-for="template in templates" :value="template.product_listing_template_id">{{ template.settings.Name }}</option>
							</select>
						</div>
						<div v-else style="margin: 0.5em;">
							No templates available.
						</div>
					</div>
					<div>
						<label>Or save as a new template...</label>
						<input type="text" v-model="newTemplateName" placeholder="New template name">
					</div>
				</div>

			</div>
			<div class="controls">
				<div class="button cancel spaced" @click="savingTemplate = false">Cancel</div>
				<div class="button action spaced" @click="saveTemplate()" :disabled="!selectedTemplateId && !newTemplateName">Save Template</div>
			</div>
		</div>
	</div>

	<div class="modal" v-if="showModal">
		<div class="inner">
			<h2>{{ $caplitalizeWords(modalForList) }}</h2>
			<div class="content">
				<ul v-if="modalList.length > 0" class="search-list">
					<li class="clickable-list-item" v-for="(listItem, index) in modalList" @click="assignItem(listItem)">{{ listItem.description || listItem.full_name }}</li>
				</ul>
				<div v-if="modalMessage" class="empty">{{ modalMessage }}</div>
			</div>
			<div class="controls">
				<div class="button cancel" @click="showModal = false">Cancel</div>
			</div>
		</div>
	</div>

	<div class="modal" v-if="showImageUpload">
		<div class="inner uploader">
			<h2>Upload Product Image</h2>
			<div class="content">
				<div class="four-one-columns">
					<div class="image-preview">
						<img v-if="currentImageSrc" :src="currentImageSrc">
					</div>
					<div>
						<vue-dropzone @vdropzone-success="uploadSuccess" ref="imageDropzone" id="image_dropzone" :options="dropzoneOptions"></vue-dropzone>
						<div style="margin: 1em 0 0 0; line-height: 2em;">
							<div class="tab-section-title">Current Image</div>
							<div class="two-columns">
								<label>Type:</label><div>{{ imageData.file_type }}</div>
								<label>Width:</label><div>{{ imageData.width }}px</div>
								<label>Height:</label><div>{{ imageData.height }}px</div>
							</div>
						</div>
					</div>
				</div>
			</div>
			<div class="controls">
				<div class="button cancel" @click="cancelImageUpload()">{{ imageUploadComplete ? 'Done With Upload' : 'Cancel' }}</div>
			</div>
		</div>
	</div>

	<div class="modal" v-if="showConfirmModal">
		<div class="inner">
			<h2>{{ confirmModalMessage }}</h2>
			<div class="content">
				<div v-if="confirmModalAction == 'save_hide_store_products'" style="margin: 0 0 1em 0;">This will <b>{{ hideStoreLocation ? 'unhide' : 'hide' }}</b> ALL of your store inventory on your website.<br>Please confirm by entering a manager code.</div>
				<div v-if="confirmModalAction == 'remove_serial_number'" style="margin: 0 0 1em 0;">This will remove serial number <b>{{ confirmModalItem }}</b> from your inventory.<br>Please confirm by selecting a reason and entering a manager code.</div>
				<div v-if="confirmModalRequireReason">
					<label>Reason Code</label>
					<select v-model="inventoryReasonCodeId">
						<option value="">Select...</option>
						<option v-for="(reasonCode, index) in inventoryReasonCodes" :value="reasonCode.inventory_reason_code_id">{{ reasonCode.description }}</option>
					</select>
				</div>
				<div v-if="confirmModalRequireManager">
					<label>Manager Code</label>
					<input type="password" v-model="managerCode"/>
				</div>
				<div v-if="confirmModalStatusMessage" class="center">{{ confirmModalStatusMessage }}</div>
			</div>
			<div class="controls">
				<div class="button cancel spaced" @click="resetConfirmModal()">Cancel</div>
				<div v-if="confirmModalAction == 'save_hide_store_products'" :class="['button', 'spaced', saving.hide_store_products ? 'warning disabled' : 'action']" @click="saveHideStoreProducts()">{{ hideStoreLocation ? 'Unhide' : 'Hide' }} All Store Products</div>
				<div v-if="confirmModalAction == 'save_prices_availability'" :class="['button', 'spaced', saving.availability ? 'warning disabled' : 'action']" @click="saveProductInfo('availability', 'availability')">Save Prices & Availability</div>
				<div v-if="confirmModalAction == 'save_prices'" :class="['button', 'spaced', saving.availability ? 'warning disabled' : 'action']" @click="saveProductInfo('availability', 'prices')">Save Prices</div>
				<div v-if="confirmModalAction == 'save_limits'" :class="['button', 'spaced', saving.limits ? 'warning disabled' : 'action']" @click="saveProductInfo('availability', 'limits')">Save Limits</div>
				<div v-if="confirmModalAction == 'save_delete'" :class="['button', 'spaced', saving.set_delete ? 'warning disabled' : 'action']" @click="deleteProduct()">Confirm</div>
				<div v-if="confirmModalAction == 'save_reorder_actions'" :class="['button', 'spaced', saving.reorder_actions ? 'warning disabled' : 'action']" @click="saveProductInfo('availability', 'reorder_actions')">Save Reorder Actions</div>
				<div v-if="confirmModalAction == 'remove_serial_number'" :class="['button', 'spaced', saving.remove_serial_number ? 'warning disabled' : 'action']" @click="removeSerialNumber(confirmModalItem)">Remove Serial Number</div>
			</div>
		</div>
	</div>

	<div class="modal image-preview" v-if="showImagePreview">
		<div class="inner">
			<h2>Image Preview</h2>
			<div class="content">
				<img v-if="productDetail.info.image_src_large" :src="productDetail.info.image_src_large">
				<img v-else-if="productDetail.info.image_src" :src="productDetail.info.image_src">
				<div v-else>Image not found</div>
			</div>
			<div class="controls">
				<div class="button cancel" @click="showImagePreview = false">Cancel</div>
			</div>
		</div>
	</div>

	<div class="modal" v-if="showChangeLogModal">
		<div class="inner">
			<h2>Change Log Detail</h2>
			<div class="content two-columns">
				<label>Date / Time</label>
				<label>User</label>
				<div>{{ changeLogDetail.log_time }}</div>
				<div>{{ changeLogDetail.user_name }}</div>
			</div>
			<div class="content two-columns">
				<label>Program / Action</label>
				<label>Reason</label>
				<div>{{ changeLogDetail.program_code }}</div>
				<div>{{ changeLogDetail.description }}</div>
			</div>
			<div class="content two-columns">
				<div style="border-bottom: 1px solid #ccc;">Previous Values</div>
				<div style="border-bottom: 1px solid #ccc;">Saved Values</div>
				<div>
					<div v-for="(value, key) in changeLogDetail.old_data" class="two-columns">
						<label>{{ key.capitalizeWords() }}</label><div class="right">{{ value }}</div>
					</div>
				</div>
				<div>
					<div v-for="(value, key) in changeLogDetail.new_data" class="two-columns">
						<label>{{ key.capitalizeWords() }}</label><div class="right">{{ value }}</div>
					</div>
				</div>
			</div>
			<div class="controls">
				<div class="button cancel" @click="showChangeLogModal = false">Cancel</div>
			</div>
		</div>
	</div>

	<div class="modal" v-if="confirmSplitItem">
		<div class="inner">
			<h2>Confirm Split Item</h2>
			<div class="content">
				{{ splitDistributorItem.company_name }} item number {{ splitDistributorItem.item_number }}<br>
				will be split into a separate set of product records.<br>
				The new set will have the same UPC {{ productDetail.info.upc }}
			</div>
			<div class="controls">
				<div class="button cancel spaced" @click="confirmSplitItem = false">Cancel</div>
				<div :class="['button', 'spaced', doingSplit ? 'disabled' : 'action']" @click="doSplitItem()">Yes, Split</div>
			</div>
		</div>
	</div>

	<div class="modal" v-if="confirmSetNotTaxable">
		<div class="inner">
			<h2>Confirm Change Not Taxable</h2>
			<div class="content">
				<p class="center"><i class="fas fa-exclamation-triangle" style="color: orange;"></i> Are you sure you want to make this change?</p>
				Changing tax status for this item impacts your Daily Cash Report and Taxable Item Report. This tax status will now apply to this item for any previous reporting period, as well as any reports going forward. Do you want to continue?
			</div>
			<div class="controls">
				<div class="button cancel spaced" @click="cancelUpdateNotTaxable()">Cancel</div>
				<div :class="['button', 'spaced', updatingNotTaxable ? 'disabled' : 'action']" @click="updateNotTaxable()">Yes, Change</div>
			</div>
		</div>
	</div>

	<div class="modal" v-if="showClassAlert">
		<div class="inner">
			<h2>New Program Available!</h2>
			<div class="content">
				<p>The new classes program allows you to set recurring dates, required registration info, related products, notification preferences and more.</p>
				<p>We recommend managing this class in the new program.</p>
			</div>
			<div class="controls">
				<div class="button cancel spaced" @click="showClassAlert = false">Not Now</div>
				<div class="button neutral spaced" @click="$router.push('/range-memberships/classes' + (productDetail.info.class_detail_id ? '/' + productDetail.info.class_detail_id : '?new=' + productDetail.info.product_id))">Manage in Classes</div>
			</div>
		</div>
	</div>

	<price-override-detail v-if="showPriceOverride" :listDetail="overridePrice" @backToList="finishedPriceOverride" :key="'override_' + overridePrice.image_src" />

	<map-policy-detail v-if="showMapPolicy" :productId="productDetail.product_id" @backToList="showMapPolicy = false" :key="'product_' + productDetail.product_id" />

	<div class="modal" v-if="showExportModal">
		<div class="inner">
			<h2>Export List</h2>
			<div class="content center">
				<p v-html="filterMessage"></p>
				<p>
					<i v-if="doExport" class="fa fa-spinner fa-spin"></i>
					<i v-else class="fa fa-check"></i>
				</p>
			</div>
			<div class="controls">
				<div class="button cancel spaced" @click="showExportModal = false">Dismiss</div>
			</div>
		</div>
	</div>

	<div class="modal" v-if="showGunBrokerConnectionModal">
		<div class="inner">
			<h2>GunBroker Connection Setup</h2>
			<div class="content">
				<p>Connect your store inventory directly to your Gunbroker account for listing and selling products.</p>
				<!-- Username and password inputs go here -->
				<label-required label="GunBroker Username" />
				<input type="text" v-model="newGunBrokerUsername">
				<label-required label="GunBroker Password" />
				<input type="password" v-model="newGunBrokerPassword">
			</div>
			<div class="controls">
				<div class="button cancel spaced" @click="cancelGunBrokerCredentialsSave">Cancel</div>
				<div class="button action spaced" @click="saveGunBrokerCredentials">Save GunBroker Connection</div>
			</div>
		</div>
	</div>

	<div class="modal" v-if="confirmEndGBItem">
		<div class="inner">
			<h2>Confirm Ending Item Early</h2>
			<div class="content">
				<p>Are you sure you would like to end the item early? This can't be undone.</p>
			</div>
			<div class="controls">
				<div class="button cancel spaced" @click="confirmEndGBItem = false">Cancel</div>
				<div class="button action spaced" @click="endGBItem">Confirm</div>
			</div>
		</div>
	</div>

	<iframe id="download" src="" style="display: none;"></iframe>

	<help-popup :helpLink="{167:'Distributor Products', 147:'Product Management', 148:'Create a New Product', 149:'Non-Inventory Products', 150:'Product Info Tab', 151:'Inventory Tab', 154:'Sales History Tab', 156:'Merge Duplicate Products'}" :tours="false"></help-popup>

	<message-modal v-if="showSaving" :message="savingMessage" :loading="loading" :errorStatus="messageStatus" :timeout="messageTimeout" @dismiss="showSaving = false" />
	
</div>
</template>

<script>
var ZEBRA_PRINTING_EXTENSION_PRESENT = false
window.addEventListener("message", function (event) {
	if (!event.data.ZebraPrintingExtensionId) {
		return;
	}
	ZEBRA_PRINTING_EXTENSION_PRESENT = true
});
import moment from 'moment-timezone';
import vue2Dropzone from 'vue2-dropzone'
import 'vue2-dropzone/dist/vue2Dropzone.min.css'

import Loading from '@/components/Loading.vue'
import LabelRequired from '@/components/LabelRequired.vue'
import Message from '@/components/Message.vue'
import ToolTip from '@/components/ToolTip.vue'
import NumberInput from '@/components/NumberInput.vue'
import TagPrint from '@/components/TagPrint.vue'
import PriceOverrideDetail from '@/components/PriceOverrideDetail.vue'
import MapPolicyDetail from '@/components/MapPolicyDetail.vue'
import Checkbox from '@/components/Checkbox.vue'
import HelpPopup from '@/components/HelpPopup.vue'
import ProductTable from '@/components/ProductTable.vue';
import ImagesManager from '@/components/ImagesManager.vue';
import Templates from '@/components/Templates.vue';
// import SelectedTemplateProperties from '@/components/SelectedTemplateProperties.vue';
import GunBrokerDescriptionField from '@/components/GunBrokerDescriptionField.vue';
import DateTimeInput from '@/components/DateTimeInput.vue';
import StateSelect from '@/components/StateSelect.vue';

// GunBroker options
const GUN_BROKER_ITEM = {
	"AutoAcceptPrice": null,
	"AutoRejectPrice": null,
	"AutoRelist": 1,
	"AutoRelistFixedCount": null,
	"BuyNowPrice": null,
	"CanOffer": null,
	"CategoryID": null,
	"CategoryName": null,
	"Characteristics": null,
	"CollectTaxes": true,
	"Condition": null,
	"CountryCode": null,
	"Description": null,
	"ExcludeStates": null,
	"FixedPrice": null,
	"InspectionPeriod": null,
	"IsFFLRequired": null,
	"ItemCharacteristics": null,
	"ListingDuration": null,
	"MfgPartNumber": null,
	"PaymentMethods": {
		"Check": null,
		"VisaMastercard": null,
		"COD": null,
		"Escrow": null,
		"Amex": null,
		"Discover": null,
		"PayPal": null,
		"CertifiedCheck": null,
		"USPSMoneyOrder": null,
		"MoneyOrder": null,
		"Financing": null
	},
	"PaymentPlan": null,
	"PictureURLs": null,
	"PremiumFeatures": {
		"SubTitle": null,
		"TitleColor": null,
		"ScheduledStartingDate": null,
		"IsShowCaseItem": false, // Feature on homepage
		"IsFeaturedItem": false,
	},
	"PostalCode": null,
	"Prop65Warning": null,
	"Quantity": null,
	"ReservePrice": null,
	"SalesTaxes": null,
	"UseDefaultExcludeStates": null,
	"UseDefaultSalesTax": null,
	"SerialNumber": null,
	"ShippingClassCosts": {
		"Overnight": null,
		"TwoDay": null,
		"ThreeDay": null,
		"Ground": null,
		"FirstClass": null,
		"Priority": null,
		"InStorePickup": null,
		"AlaskaHawaii": null,
		"Other": null
	},
	"ShippingClassesSupported": {
		"Overnight": null,
		"TwoDay": null,
		"ThreeDay": null,
		"Ground": null,
		"FirstClass": null,
		"Priority": null,
		"InStorePickup": null,
		"AlaskaHawaii": null,
		"Other": null
	},
	"ShippingProfileID": null,
	"SKU": null,
	"StandardTextID": null,
	"StartingBid": null,
	"Title": null,
	"UPC": null,
	"Weight": null,
	"WeightUnit": 1,
	"WhoPaysForShipping": null,
	"WillShipInternational": false,
}
const GUN_BROKER_ITEM_TEMPLATE_STANDARD_AUCTION = {
	StartingBid: {
		data: null,
		label: "Starting Bid",
		required: true,
		selected: true
	},
	ReservePrice: {
		data: null,
		label: "Reserve Price",
		required: false,
		selected: true
	},
	BuyNowPrice: {
		data: null,
		label: "Buy Now Price",
		required: false,
		selected: true
	},
	ListingDuration: {
		data: null,
		label: "Listing Duration",
		required: true,
		selected: true
	},
	AutoRelist: {
		data: null,
		label: "Auto Relist",
		required: false,
		selected: true
	},
	AutoRelistFixedCount: {
		data: null,
		label: "Times To Auto Relist",
		required: true,
		selected: true
	},
}
const GUN_BROKER_ITEM_TEMPLATE_SHORT_TERM_AUCTION = {
	StartingBid: {
		data: null,
		label: "Starting Bid",
		required: true,
		selected: true
	},
	BuyNowPrice: {
		data: null,
		label: "Buy Now Price",
		required: false,
		selected: true
	},
	ListingDuration: {
		data: null,
		label: "Listing Duration",
		required: true,
		selected: true
	},
	AutoRelist: {
		data: null,
		label: "Auto Relist",
		required: false,
		selected: true
	},
	AutoRelistFixedCount: {
		data: null,
		label: "Times To Auto Relist",
		required: true,
		selected: true
	},
}
const GUN_BROKER_ITEM_TEMPLATE_FIXED_PRICE = {
	FixedPrice: {
		data: null,
		label: "Fixed Price",
		required: true,
		selected: true
	},
	Quantity: {
		data: null,
		label: "Quantity",
		required: true,
		selected: true
	},
	ListingDuration: {
		data: null,
		label: "Listing Duration",
		required: true,
		selected: true
	},
	AutoRelist: {
		data: null,
		label: "Auto Relist",
		required: false,
		selected: true
	},
	AutoRelistFixedCount: {
		data: null,
		label: "Times To Auto Relist",
		required: true,
		selected: true
	},
	CanOffer: {
		data: null,
		label: "Accept Offers",
		required: false,
		selected: true
	},
	AutoAcceptPrice: {
		data: null,
		label: "Auto Accept Price",
		required: true,
		selected: true
	},
	AutoRejectPrice: {
		data: null,
		label: "Auto Reject Price",
		required: true,
		selected: true
	},
}
const GUN_BROKER_ITEM_TEMPLATE = {
	Title: {
		data: null,
		label: "Title",
		required: false,
		selected: false
	},
	Description: {
		data: null,
		label: "Description",
		required: false,
		selected: false
	},
	Category: {
		data: {
			CategoryID: null,
			CategoryName: null,
			selectedGunBrokerCategories: []
		},
		label: "GunBroker Category",
		required: true,
		selected: true
	},
	CollectTaxes: {
		data: null,
		label: "Collect Taxes",
		required: false,
		selected: true
	},
	Condition: {
		data: null,
		label: "Condition",
		required: true,
		selected: true
	},
	CountryCode: {
		data: null,
		label: null,
		required: true,
		selected: true
	},
	ExcludeStates: {
		data: null,
		label: "Excluded States",
		required: false,
		selected: false
	},
	InspectionPeriod: {
		data: null,
		label: "Inspection Period",
		required: false,
		selected: false
	},
	IsFFLRequired: {
		data: null,
		label: "FFL Required",
		required: false,
		selected: true
	},
	ItemCharacteristics: {
		data: null,
		label: "Item Characteristics",
		required: false,
		selected: false
	},
	MfgPartNumber: {
		data: null,
		label: "Manufacturer Part Number",
		required: false,
		selected: false
	},
	PaymentMethods: {
		data: null,
		label: "Payment Methods",
		required: true,
		selected: true
	},
	PaymentPlan: {
		data: null,
		label: "Layaway Available",
		required: false,
		selected: true
	},
	PictureURLs: {
		data: null,
		label: "Images",
		required: false,
		selected: true
	},
	PostalCode: {
		data: null,
		label: "Zip Code",
		required: false,
		selected: true
	},
	PremiumFeatures: {
		data: {
			SubTitle: null,
			TitleColor: null,
			ScheduledStartingDate: null,
			IsShowCaseItem: false, // Feature on homepage
			IsFeaturedItem: false,
		},
		label: "Premium Features",
		required: false,
		selected: false
	},
	Prop65Warning: {
		data: null,
		label: "California Prop 65 Text",
		required: false,
		selected: false
	},
	ShippingClassCosts: {
		data: null,
		label: "Shipping Class Costs",
		required: true,
		selected: true
	},
	ShippingClassesSupported: {
		data: null,
		label: "Supported Shipping Classes",
		required: true,
		selected: true
	},
	SKU: {
		data: null,
		label: "SKU",
		required: false,
		selected: true,
	},
	StandardTextID: {
		data: null,
		label: "Additional Terms of Sale",
		required: false,
		selected: false
	},
	UPC: {
		data: null,
		label: "UPC",
		required: false,
		selected: true,
	},
	Weight: {
		data: null,
		label: "Weight",
		required: false,
		selected: true
	},
	WeightUnit: {
		data: null,
		label: "Weight unit",
		required: false,
		selected: true
	},
	WhoPaysForShipping: {
		data: null,
		label: "Who Pays for Shipping",
		required: true,
		selected: true
	},
	WillShipInternational: {
		data: null,
		label: "Will Ship Internationally",
		required: false,
		selected: true
	},
}
const AUTO_RELIST = [
	{ id: 1, label: "Do Not Relist" },
	{ id: 2, label: "Relist Until Sold" },
	{ id: 3, label: "Relist Fixed Count" },
	{ id: 4, label: "Relist Fixed Price" },
];
const CONDITION = [
	{ id: 1, label: "Factory New" },
	{ id: 2, label: "New Old Stock" },
	{ id: 3, label: "Used" },
];
const LISTING_DURATION = [
{ id: 1 },
{ id: 3 },
{ id: 4 },
{ id: 5 },
{ id: 6 },
{ id: 7 },
{ id: 8 },
{ id: 9 },
{ id: 10 },
{ id: 11 },
{ id: 12 },
{ id: 13 },
{ id: 14 },
{ id: 30 },
{ id: 60 },
{ id: 90 },
];
const WHO_PAYS_FOR_SHIPPING = [
	{ id: 2, label: "Seller pays for shipping" },
	{ id: 3, label: "Seller pays for shipping (see item description)" },
	{ id: 4, label: "Buyer pays actual shipping cost" },
	{ id: 5, label: "Buyer pays actual shipping cost (see item description)" },
	{ id: 8, label: "Buyer pays fixed amount" },
	{ id: 9, label: "Buyer pays fixed amount (see item description)" },
];
const SHIPPING_CLASSES_SUPPORTED = [
	{ id: "Overnight", label: "Overnight" },
    { id: "TwoDay", label: "2nd Day" },
    { id: "ThreeDay", label: "3rd Day" },
    { id: "Ground", label: "Ground" },
    { id: "FirstClass", label: "USPS First Class" },
    { id: "Priority", label: "USPS Priority Mail" },
    { id: "InStorePickup", label: "In Store Pickup" },
    { id: "AlaskaHawaii", label: "Alaska, Hawaii & US Terr." },
    { id: "Other", label: "Other" }
];

const PAYMENT_METHODS = [
	{ id: "VisaMastercard", label: "Visa/Mastercard" },
	{ id: "Amex", label: "American Express" },
	{ id: "Discover", label: "Discover" },
	{ id: "Check", label: "Personal Check" },
	{ id: "CertifiedCheck", label: "Certified Check" },
	{ id: "USPSMoneyOrder", label: "USPS Money Order" },
	{ id: "MoneyOrder", label: "Money Order" },
	{ id: "COD", label: "COD (Collect on Delivery)" },
	{ id: "Escrow", label: "GunTab Escrow" },
]

const INSPECTION_PERIODS = [
	{ id: 1, label: "AS IS No refund or exchange" },
	{ id: 2, label: "No refund but item can be returned for exchange or store credit within fourteen days" },
	{ id: 3, label: "No refund but item can be returned for exchange or store credit within thirty days" },
	{ id: 4, label: "Three Days from the date the item is received" },
	{ id: 5, label: "Three Days from the date the item is received, including the cost of shipping" },
	{ id: 6, label: "Five Days from the date the item is received" },
	{ id: 7, label: "Five Days from the date the item is received, including the cost of shipping" },
	{ id: 8, label: "Seven Days from the date the item is received" },
	{ id: 9, label: "Seven Days from the date the item is received, including the cost of shipping" },
	{ id: 10, label: "Fourteen Days from the date the item is received" },
	{ id: 11, label: "Fourteen Days from the date the item is received, including the cost of shipping" },
	{ id: 12, label: "30 day money back guarantee" },
	{ id: 13, label: "30 day money back guarantee including the cost of shipping" },
	{ id: 14, label: "Factory Warranty" },
];

export default {
	name: 'manage-products',
	props: ['owner', 'product_id'],
    components: {
        'loading': Loading,
		'label-required': LabelRequired,
        'message': Message,
		'tool-tip': ToolTip,
		'number-input': NumberInput,
        'tag-print': TagPrint,
		'price-override-detail': PriceOverrideDetail,
		'map-policy-detail': MapPolicyDetail,
		'checkbox': Checkbox,
		'help-popup': HelpPopup,
		'product-table': ProductTable,
		'images-manager': ImagesManager,
		'templates': Templates,
		// 'selected-template-properties': SelectedTemplateProperties,
		'gun-broker-description-field': GunBrokerDescriptionField,
		'date-time-input': DateTimeInput,
		'state-select': StateSelect,
    },
	data() {
		return {
			client_id: '',
			loading: false,
			showFilters: true,
			showListOnly: false,
			filters: {},
			paging: {},
			list: [],
			noMatchFound: null,
			usesWebsiteBuilder: false,
			hideStoreLocation: false,
			modalMessage: '',
			modalList: [],
			modalForList: '',
			modalContext: '',
			showModal: false,
			showConfirmModal: false,
			confirmModalMessage: '',
			confirmModalRequireReason: false,
			confirmModalRequireManager: false,
			confirmModalAction: '',
			confirmModalItem: '',
			confirmModalStatusMessage: '',
			inventoryReasonCodes: [],
			inventoryReasonCodeId: '',
			managerCode: '',
			showDetail: false,
			showDetailTab: '',
			productDetail: {},
			productDetailListIndex: 0,
			detailCategories: {},
			productTypes: [],
			departments: [],
			distributors: [],
			loadingFilterLists: false,
			categories: {},
			manufacturers: {},
			calibers: {},
			product_descriptors: [],
			product_notices_system: [],
			product_notices_client: [],
			sales_history: [],
			change_log: [],
			showChangeLogModal: false,
			changeLogDetail: {},
			dymoPrinterFound: false,
			showImagePreview: false,
			showImageUpload: false,
			imageData: {},
			imageKey: Math.random().toString(8),
			currentImageSrc: '',
			imageUploadComplete: false,
			newProductNotice: {
				description: '',
				notice: ''
			},
			newProductDescriptor: {
				descriptor_id: '',
				content: ''
			},
			saving: {
				info: false,
				availability: false,
				prices: false,
				limits: false,
				reorder_actions: false,
				set_delete: false,
				specifications: false,
				shipping: false,
				new_product_notice: false,
				remove_serial_number: false,
				hide_store_products: false
			},
			saveMessage: {
				info: '',
				availability: '',
				prices: '',
				limits: '',
				reorder_actions: '',
				set_delete: '',
				specifications: '',
				shipping: '',
				new_product_notice: '',
				remove_serial_number: '',
				hide_store_products: ''
			},
			showSaving: false,
			savingMessage: '',
			messageStatus: '',
			messageTimeout: 0,
			reloadListAfterSave: false,
			doExport: false,
			zebraPrintingExtensionPresent: ZEBRA_PRINTING_EXTENSION_PRESENT,
			updatingNotTaxable: false,
			confirmSplitItem: false,
			splitDistributorItem: {},
			doingSplit: false,
			overridePrice: {},
			showPriceOverride: false,
			showMapPolicy: false,
			addingToCart: false,
			addToCartMessage: '',
			showClassAlert: false,
			returnRoute: '',
			confirmSetNotTaxable: false,
			showExportModal: false,
			filterMessage: '',
			showGunBrokerConnectionModal: false,
			mustEnterGunBrokerCredentials: false,
			gunBrokerUsername: '',
			gunBrokerPassword: '',
			newGunBrokerUsername: '',
			newGunBrokerPassword: '',
			showGBItemDetail: false,
			gunBrokerCategories: [],
			loadingGunBrokerCategories: false,
			selectedGunBrokerCategories: [],
			gunBrokerEnabled: false,
			gunBrokerCondition: CONDITION,
			gunBrokerAutoRelist: AUTO_RELIST,
			gunBrokerListingDuration: {
				"Standard Auction": LISTING_DURATION.filter(duration => duration.id >= 4 && duration.id <= 14),
				"Short-Term Auction": LISTING_DURATION.filter(duration => duration.id <= 3),
				"Fixed Price": LISTING_DURATION.filter(duration => duration.id >= 30)
			},
			gunBrokerWhoPaysForShipping: WHO_PAYS_FOR_SHIPPING,
			gunBrokerShippingClassesSupported: SHIPPING_CLASSES_SUPPORTED,
			gunBrokerPaymentMethods: PAYMENT_METHODS,
			gunBrokerInspectionPeriods: INSPECTION_PERIODS,
			gunBrokerItemsBySn: {},
			gunBrokerAllocateProduct: true,
			gunBrokerQuantityToAllocate: 1,
			gbListingType: 'Standard Auction',
			confirmEndGBItem: false,
			productClientDataId: null,
			gunBrokerPictureURLs: [],
			gunBrokerItemDetail: JSON.parse(JSON.stringify(GUN_BROKER_ITEM)),
			gunBrokerItemDetailCopy: JSON.parse(JSON.stringify(GUN_BROKER_ITEM)),
			gunBrokerItemDetailMeta: {
				SubTitle: false,
				TitleColor: false,
				ScheduleStartingDate: false,
				ExcludeStates: false,
				IsShowCaseItem: false, // Feature on homepage
				IsFeaturedItem: false,
			},
			gunBrokerStandardTextList: [],
			gunBrokerScheduledStartingDate: null,
			gunBrokerSelectedState: '',
			templates: [],
            selectedTemplateId: null,
            savingTemplate: false,
            newTemplateName: '',
			templateGroupCode: 'GUN_BROKER',
			gunBrokerInvalidFields: []
		}
	},
	created() {
		this.clearFilters()
		this.resetProductDetail()
		this.getDepartments()
		if (this.owner == 'distributor') {
			this.getDistributors()
		}
		this.returnRoute = this.$route.query.return
		if (this.product_id) {
			this.getDetail(this.product_id)
		}
	},
    computed: {
		hasFilters() {
			for (const [key, value] of Object.entries(this.filters)) {
				if (['search_term', 'in_stock', 'out_of_stock', 'hidden', 'deleted', 'no_image', 'no_category', 'not_taxable', 'department_id', 'category_id', 'manufacturer_id', 'caliber_id', 'product_id', 'no_manufacturer', 'no_caliber', 'no_shipping_info', 'gunbroker_status'].includes(key) && value) {
					return true
				}
			}
			return false
		},
		showPagination() {
			return this.paging.total_pages
		},
		userCanEdit() {
			return this.productDetail.info.client_id == this.client_id || this.getAdministratorFlag
		},
		userCanSave() {
			if (this.productDetail.info.upc && this.productDetail.info.description && this.productDetail.info.category_id) {
				return true
			}
			return false
		},
		thisCost() {
			if (this.productDetail && this.productDetail.availability && this.productDetail.availability.cost) {
				return this.productDetail.availability.cost
			} else {
				return 0
			}
		},
		thisPrice() {
			if (this.productDetail && this.productDetail.availability && this.productDetail.availability.price) {
				return this.productDetail.availability.price
			} else {
				return 0
			}
		},
		thisWebPrice() {
			if (this.productDetail && this.productDetail.availability && this.productDetail.availability.web_price) {
				return this.productDetail.availability.web_price
			} else {
				return 0
			}
		},
		neverReceived() {
			return !this.productDetail.availability.on_hand && !this.productDetail.availability.cost && !this.productDetail.availability.price && !this.productDetail.availability.web_price
		},
		gunBrokerItemNotes() {
			const notes = [];
			if (this.gunBrokerItemDetail.ItemID) {
				if (this.gunBrokerItemHasEnded) {
					notes.push({
						message: 'This GunBroker item listing has ended and cannot be edited.',
						color: 'yellow',
						icon: 'fas fa-info'
					});
				} else if (this.gunBrokerItemHasSold) {
					if (this.gunBrokerItemDetail.LocalOrderID) {
						notes.push({
							message: 'This item has sold!',
							color: 'green',
							icon: 'fas fa-info',
							link: {
								text: `View Order.`,
								url: `https://${this.getClient.primary_domain}/dashboard/orders-sales/orders/detail/${this.gunBrokerItemDetail.LocalOrderID}`
							}
						});
					} else if (this.gunBrokerItemDetail.LocalShoppingCartID) {
						notes.push({
							message: 'This item has sold!',
							color: 'green',
							icon: 'fas fa-info',
							link: {
								text: `View Cart.`,
								url: `https://${this.getClient.primary_domain}/dashboard/orders-sales/carts/${this.gunBrokerItemDetail.LocalShoppingCartID}`
							}
						});
					}
				} else if (this.gunBrokerItemDetail.Bids > 0) {
					notes.push({
						message: 'This item has bids and cannot be edited.',
						color: 'warning',
						icon: 'fas fa-exclamation-triangle'
					});
				} else {
					notes.push({
						message: 'Changes made to this listing outside of Flight Deck will not be reflected here.<br>Changes to images and other "locked" fields must be made directly on GunBroker.<br>Bids will update for auction items.',
						color: 'green',
						icon: 'fas fa-info'
					});
				}
			} else {
				if (this.productDetail.availability.on_hand < 1) {
					notes.push({
						message: 'This product is out of stock and cannot be listed on GunBroker.',
						color: 'warning',
						icon: 'fas fa-exclamation-triangle'
					});
				}
			}
			const now = moment.tz("America/New_York");
			if (this.gunBrokerItemDetail.ItemID && this.gunBrokerItemDetailMeta?.ScheduleStartingDate) {
				const startDate = moment.utc(this.gunBrokerItemDetail.StartingDate).tz("America/New_York");;
				if (startDate.isAfter(now)) {
					notes.push({
						message: `This listing is scheduled to start on ${startDate.format('M/D/YYYY h:mm A')} ET.`,
						color: 'yellow',
						icon: 'fas fa-info'
					});
				}
			}
			return notes;
		},
		canEditGunBrokerItem() {
			return !this.gunBrokerItemHasSold && !this.gunBrokerItemHasEnded && !this.gunBrokerItemDetail.Bids && this.productDetail.availability.on_hand > 0
		},
		gunBrokerCategoryID() {
			if (!this.selectedGunBrokerCategories.length) return null;
			let category = this.selectedGunBrokerCategories[this.selectedGunBrokerCategories.length - 1];
			if (category && category.categoryID && (category.hasSubCategories === false || category.canContainItems === true)) {
				return category.categoryID;
			} else {
				return null;
			}
		},
		gbListingTypeLabel() {
			if (this.gunBrokerItemDetail.ListingDuration <= 3) {
				return 'Short-Term Auction';
			} else if (this.gunBrokerItemDetail.ListingDuration >= 4 && this.gunBrokerItemDetail.ListingDuration <= 14) {
				return 'Standard Auction';
			} else if (this.gunBrokerItemDetail.ListingDuration >= 30) {
				return 'Fixed Price';
			}
			return '';
		},
		gbSerialNumbersColumns() {
			const h = this.$createElement;
			return [
				{ label: 'Serial Number', key: 'serial_number', sortable: false, width: '40%' },
				{
					label: 'Listed',
					key: 'listed',
					align: 'center',
					sortable: false,
					width: '60%',
					renderFunction: (item) => {
						return item.listed ? '<span class="fas fa-square-check" style="color: green;"></span>' : ''
					}
				}
			]
		},
		gbSerialNumbersData() {
			return this.productDetail.availability.serial_numbers.map(sn => {
				return {
					serial_number: sn,
					listed: this.gunBrokerItemsBySn[sn] ? true : false
				}
			})
		},
		validateShippingClasses() {
			let invalid = [];
			Object.keys(this.gunBrokerItemDetail.ShippingClassesSupported).forEach(key => {
				// Buyer pays fixed... requries a cost, even if zero
				if (this.gunBrokerItemDetail.WhoPaysForShipping >= 8 && this.gunBrokerItemDetail.ShippingClassesSupported[key] === true && !this.gunBrokerItemDetail.ShippingClassCosts[key]) {
					invalid.push(key);
				}
			});
			return invalid.length === 0;
		},
		validatePaymentMethods() {
			let valid = [];
			Object.keys(this.gunBrokerItemDetail.PaymentMethods).forEach(key => {
				if (this.gunBrokerItemDetail.PaymentMethods[key] === true) {
					valid.push(key);
				}
			});
			return valid.length !== 0;
		},
		validateGunBrokerItem() {
			this.gunBrokerInvalidFields = [];
			if (this.gunBrokerAllocateProduct && (this.gunBrokerQuantityToAllocate < 1 || this.gunBrokerQuantityToAllocate > this.productDetail.availability.on_hand)) {
				this.gunBrokerInvalidFields.push('gunBrokerQuantityToAllocate');
				return false
			}

			if (!this.canEditGunBrokerItem) return false

			if (!this.gunBrokerItemDetail.Title || !this.gunBrokerItemDetail.Description) {
				console.log(1);
				this.gunBrokerInvalidFields.push('Title or Description');
				return false;
			}
			if (!this.gunBrokerItemDetail.CategoryID && !this.gunBrokerCategoryID) {
				console.log(this.gunBrokerItemDetail.CategoryID, this.gunBrokerCategoryID);
				console.log(2);
				this.gunBrokerInvalidFields.push('CategoryID');
				return false;
			}
			if (this.gunBrokerItemDetail.Condition === null) {
				console.log(3);
				this.gunBrokerInvalidFields.push('Condition');
				return false;
			}
			if (this.gunBrokerItemDetail.ListingDuration === null) {
				console.log(4);
				this.gunBrokerInvalidFields.push('ListingDuration');
				return false;
			}
			if (this.gbListingType === 'Short-Term Auction' || this.gbListingType === 'Standard Auction') {
				if (this.gunBrokerItemDetail.StartingBid === null || this.gunBrokerItemDetail.StartingBid <= 0) {
					console.log(5.1);
					this.gunBrokerInvalidFields.push('StartingBid');
					return false;
				}
				if (this.gunBrokerItemDetail.BuyNowPrice !== null && this.gunBrokerItemDetail.BuyNowPrice !== '' && this.gunBrokerItemDetail.StartingBid > this.gunBrokerItemDetail.BuyNowPrice) {
					this.gunBrokerInvalidFields.push('BuyNowPrice');
					console.log(5.2);
					return false;
				}
				if (this.gunBrokerItemDetail.ListingDuration === null) {
					console.log(5.3);
					this.gunBrokerInvalidFields.push('ListingDuration');
					return false;
				}
				if (this.gunBrokerItemDetail.AutoRelist === 3
					&& (this.gunBrokerItemDetail.AutoRelistFixedCount === null
						|| this.gunBrokerItemDetail.AutoRelistFixedCount < 1
						|| (this.gunBrokerAllocateProduct && this.gunBrokerItemDetail.AutoRelistFixedCount > this.gunBrokerQuantityToAllocate))) {
					console.log(5.4);
					this.gunBrokerInvalidFields.push('AutoRelistFixedCount');
					return false;
				}
			}
			if (this.gbListingType === 'Standard Auction' && this.gunBrokerItemDetail.ReservePrice !== null && this.gunBrokerItemDetail.ReservePrice !== '' && this.gunBrokerItemDetail.StartingBid >= this.gunBrokerItemDetail.ReservePrice) {
				console.log(6, this.gunBrokerItemDetail.ReservePrice !== null);
				console.log(typeof this.gunBrokerItemDetail.ReservePrice);
				this.gunBrokerInvalidFields.push('ReservePrice');
				return false;
			}
			if (this.gbListingType === 'Fixed Price' && (this.gunBrokerItemDetail.Quantity <= 0 || this.gunBrokerItemDetail.FixedPrice === null || this.gunBrokerItemDetail.FixedPrice <= 0)) {
				console.log(7);
				this.gunBrokerInvalidFields.push('Quantity or FixedPrice');
				return false;
			}
			if (this.gunBrokerItemDetail.WhoPaysForShipping === null) {
				console.log(8);
				this.gunBrokerInvalidFields.push('WhoPaysForShipping');
				return false;
			}
			if (!this.validateShippingClasses) {
				console.log(9);
				this.gunBrokerInvalidFields.push('ShippingClasses');
				return false;
			}
			if (!this.validatePaymentMethods) {
				console.log(10);
				this.gunBrokerInvalidFields.push('PaymentMethods');
				return false;
			}
			return true;
		},
		gunBrokerItemLink() {
			if (!this.gunBrokerItemDetail.Links) return null;
			const link = this.gunBrokerItemDetail.Links.find(l => l.rel === 'share');
			if (link && link.href) {
				return link.href;
			}
		},
		gunBrokerItemHasSold() {
			if (!this.gunBrokerItemDetail.EndingDate) return false
			const endingDate = this.$moment(this.gunBrokerItemDetail.EndingDate)
			if (this.gunBrokerItemDetail.HasWinningBid && this.$moment().isAfter(endingDate)) {
				return true
			}
			return false
		},
		gunBrokerItemHasEnded() {
			if (!this.gunBrokerItemDetail.EndingDate) return false
			const endingDate = this.$moment(this.gunBrokerItemDetail.EndingDate)
			if (!this.gunBrokerItemDetail.HasWinningBid && this.$moment().isAfter(endingDate)) {
				return true
			}
			return false
		},
		getGunBrokerItemDetailChangedItems() {
			// Check if any of the fields have changed from the original copy and return a list of changed fields
			const changes = {};
			Object.keys(this.gunBrokerItemDetail).forEach(key => {
				if (JSON.stringify(this.gunBrokerItemDetail[key]) !== JSON.stringify(this.gunBrokerItemDetailCopy[key])) {
					changes[key] = this.gunBrokerItemDetail[key]
				}
			});
			return Object.keys(changes).length ? changes : null;
		},
		gunBrokerCurrentTemplateData() {
			let template = { ...GUN_BROKER_ITEM_TEMPLATE };
			// Now only include the listing type specific fields
			switch (this.gbListingType) {
				case 'Standard Auction':
					template = { ...template, ...GUN_BROKER_ITEM_TEMPLATE_STANDARD_AUCTION };
					break;
				case 'Short-Term Auction':
					template = { ...template, ...GUN_BROKER_ITEM_TEMPLATE_SHORT_TERM_AUCTION };
					break;
				case 'Fixed Price':
					template = { ...template, ...GUN_BROKER_ITEM_TEMPLATE_FIXED_PRICE };
					break;
			}
			Object.keys(template).forEach(key => {
				if (key !== 'Category') {
					template[key].data = this.gunBrokerItemDetail[key]
					template[key].selected = template[key].data !== null && template[key].data !== undefined && !(typeof template[key].data === 'object' && Object.keys(template[key].data).length === 0)
				}
			});
			
			template.Category.data.CategoryID = this.gunBrokerCategoryID
			template.Category.data.CategoryName = this.selectedGunBrokerCategories.length ? this.selectedGunBrokerCategories[this.selectedGunBrokerCategories.length - 1].categoryName : null
			template.Category.selected = true;

			return template;
		},	
		selectedTemplate: {
            get() {
                return this.templateMap[this.selectedTemplateId] || { name: '', settings: {} };
            },
            set(value) {
                if (this.selectedTemplateId && this.templateMap[this.selectedTemplateId]) {
                    this.templateMap[this.selectedTemplateId].name = value.name;
                }
            }
        },
        templateMap() {
            const map = {};
            this.templates.forEach(template => {
                map[template.product_listing_template_id] = template;
                map[template.product_listing_template_id].Name = template.settings.Name;
            });            
            return map;
        },
		scheduledStartingDateError() {
			if (this.gunBrokerItemDetail.ItemID) return false;

			if (this.gunBrokerItemDetailMeta?.ScheduleStartingDate && this.gunBrokerItemDetail.PremiumFeatures.ScheduledStartingDate) {
				const selectedDate = moment(this.gunBrokerItemDetail.PremiumFeatures.ScheduledStartingDate).tz("America/New_York");;
				if (!selectedDate.isValid()) {
					return false;
				}
				const now = moment().tz("America/New_York");
				
				if (selectedDate.isBefore(now, 'minute')) {
					return true;
				}
			}
			return false;
		},
		gunBrokerExcludedStates: {
			get() {
				const s = this.gunBrokerItemDetail?.ExcludeStates;
				if (!s) return [];
				return s
					.split(',')
					.map(x => x.trim())
					.filter(Boolean);
			},
			set(arr) {
				this.gunBrokerItemDetail.ExcludeStates = (arr ?? [])
					.map(x => String(x).trim())
					.filter(Boolean)
					.join(',');
			}
		},
		selectedStandardText() {
			if (!this.gunBrokerItemDetail.StandardTextID) return null;
			return this.gunBrokerStandardTextList.find(text => text.objectID === this.gunBrokerItemDetail.StandardTextID) || null;
		}
    },
	watch: {
		thisCost: function (newVal) {
			this.calculateProfit()
		},
		thisPrice: function (newVal) {
			this.calculateProfit()
		},
		thisWebPrice: function (newVal) {
			this.calculateProfit()
		},
	    owner: function(newVal) {
			this.clearFilters()
			this.showDetail = false
			this.resetProductDetail()
	    },
		showDetail: function(newVal, oldVal) {			
			if (newVal === false && oldVal === true) {				
				this.resetGunBrokerItem();
				this.selectedTemplateId = null;
				this.localCurrentTemplateData = null;
			}
		},
		showGunBrokerConnectionModal: function(newVal) {
			if (newVal && !this.mustEnterGunBrokerCredentials) {
				this.gunBrokerUsername = ''
				this.gunBrokerPassword = ''
				this.apiCall({ destination: 'gun_broker_get_user_credentials' }).then(obj => {
					if (obj.status == 'success') {
						this.gunBrokerUsername = obj.username
						this.newGunBrokerUsername = obj.username
						this.gunBrokerPassword = obj.password
						this.newGunBrokerPassword = obj.password
					}
				}).catch(err => {
					console.error('Error fetching GunBroker credentials:', err);
				})
			}
		},
		gunBrokerCurrentTemplateData: {
            handler(newVal) {
                this.localCurrentTemplateData = newVal ? JSON.parse(JSON.stringify(newVal)) : null;
            },
            immediate: true,
            deep: true
        },
		gunBrokerScheduledStartingDate: function(newVal) {
			if (newVal && !this.gunBrokerItemDetail.ItemID) {
				this.gunBrokerItemDetail.PremiumFeatures.ScheduledStartingDate = newVal.format('YYYY-MM-DDTHH:mm');
			} else if (!this.gunBrokerItemDetail.ItemID) {
				this.gunBrokerItemDetail.PremiumFeatures.ScheduledStartingDate = null;
			}
		},
	},
	methods: {
		resetProductDetail() {
			this.productDetail = {
				product_id: '',
				description: '',
				info: {
					department_id: '',
					category_id: '',
					product_type_id: ''
				},
				availability: {
					cost: '',
					price: '',
					web_price: '',
					require_customer: '',
					per_checkout: '',
					serial_numbers: [],
					overrides: [],
					distributors: []
				},
				print_tags: {},
				specifications: {},
				shipping: {},
				sales: {},
				change_log: []
			}
		},
		clearFilters() {
			this.filters = {
				page: 1,
				search_term: '',
				in_stock: false,
				out_of_stock: false,
				hidden: false,
				not_taxable: false,
				deleted: false,
				no_image: false,
				product_id: '',
				get_inventory: true,
				image_size: 'tiny',
				distributor: '',
				distributor_id: '',
				department: '',
				department_id: '',
				category: '',
				category_id: '',
				manufacturer: '',
				manufacturer_id: '',
				caliber: '',
				caliber_id: '',
				product_type_code: '',
				gunbroker_status: '',
				owner: this.owner,
				include_deactivated_distributors: false,
				no_manufacturer: false,
				no_caliber: false,
				no_product_type: false,
				no_shipping_info: false,
				no_category: false,
				sort_by: '',
				sort_order: 'asc'
			}
			this.categories = {}
			this.manufacturers = {}
			this.calibers = {}
			if (this.$route.query.search_term) {
				this.filters.search_term = this.$route.query.search_term
			}
			this.showListOnly = false
			this.getList()
		},
		toggleFilter(which) {
			if (which == 'owner') {
				this.filters.owner = this.filters.owner == 'store' ? 'distributor' : 'store'
			} else {
				this.filters[which] = !this.filters[which]
				if (which == 'in_stock' && this.filters.in_stock) {
					this.filters.out_of_stock = false
				}
				if (which == 'out_of_stock' && this.filters.out_of_stock) {
					this.filters.in_stock = false
				}
			}
			this.filters.page = 1
			this.getList()
		},
		setSortBy(which) {
			if (this.filters.sort_by != which) {
				this.filters.sort_by = which
				this.filters.sort_order = which == 'quantity' ? 'desc' : 'asc'
			} else {
				this.filters.sort_order = this.filters.sort_order == 'asc' ? 'desc' : 'asc'
			}
			this.filters.page = 1
			this.getList()
		},
		getList() {
			if (this.loading) { return }
			this.noMatchFound = null
			this.reloadListAfterSave = false
			if (this.filters.owner == 'store' || this.hasFilters) {
				if (this.doExport)  {
					this.showExportModal = true
					this.filterMessage = 'Generating export file...'
				} else {
		            this.loading = true
				}
				this.showDetail = false
				let postObject = JSON.parse(JSON.stringify(this.filters));
				postObject.ignore_availability = !this.filters.in_stock
				postObject.export = this.doExport
				this.apiCall({ destination: 'get_list_products', data: postObject }).then(obj => {
					this.filters.get_filters = false
					if (this.doExport) {
						this.doExport = false
						document.getElementById("download").src = obj.download_url
						this.filterMessage  = 'Items exported to file<br>' + obj.file_name
						this.filterMessage += '<br><br>Download didn\'t complete?<br><a href="' + obj.download_url + '" target="_blank">Click here to download...</a>'
					} else {
						this.loading = false
						this.client_id = obj.client_id
						this.list = obj.list || []
						if (obj.pagination) {
							this.paging = obj.pagination
						}
						if (obj.filter_lists) {
							this.categories = obj.filter_lists.categories
							this.manufacturers = obj.filter_lists.manufacturers
							this.calibers = obj.filter_lists.calibers
						}
						this.gunBrokerEnabled = obj.gunbroker_enabled
						this.usesWebsiteBuilder = obj.template_type_code == 'WEBSITE_BUILDER'
						this.hideStoreLocation = obj.hide_store_location
						if (this.list.length == 0) {
							this.noMatchFound = this.filters.search_term
						} else if (this.list.length == 1) {
							this.getDetail(this.list[0])
						} else {
							// adding_to_cart
							this.list.forEach((item) => {
								item.adding_to_cart = false
							})
						}
					}
				}).catch(err => {
	                this.loading = false
					console.log(err)
				})
			} else {
				this.paging =  {}
				this.list = []
			}
		},
		exportList() {
			this.doExport = true
			this.getList()
		},
		doSearch() {
			this.filters.page = 1
			this.getList()
		},
		goToPage(page) {
			this.filters.page = page
			this.getList()
		},
		getDistributors() {
			let destination = this.getAdministratorFlag ? 'get_list_system_distributors' : 'get_list_client_distributors_for_inventory'
			this.apiCall({ destination: destination }).then(obj => {
				this.distributors = obj.distributors
			}).catch(err => {
				console.log(err)
			})
		},
		getDepartments() {
			this.apiCall({ destination: 'get_list_departments', data: { inventory_only: this.filters.owner ? this.filters.owner != 'store' : false } }).then(obj => {
				this.departments = obj.departments
			}).catch(err => {
				console.log(err)
			})
		},
		setDepartment() {
			this.categories = {}
			this.filters.page = 1
			this.filters.get_filters = true
			this.getList()
			if (this.productTypes.length == 0) {
				this.getProductTypes()
			}
			//if (this.filters.department_id) {
			//	this.getListFilters()
			//}
		},
		getCategories(departmentId, resetCategoryId) {
			if (this.showDetailTab == 'info' && resetCategoryId) {
				this.productDetail.info.category_id = ''
			}
			this.apiCall({ destination: 'get_list_categories', data: { department_id: departmentId } }).then(obj => {
				this.detailCategories = obj.categories
			}).catch(err => {
				console.log(err)
			})
		},
		resetList() {
			this.filters.page = 1
			this.getList()
		},
		getFilterList(listFor, context) {
			let searchTerm = ''
			if (context == 'info') {
				this.productDetail.info[listFor + '_id'] = ''
				searchTerm = this.productDetail.info[listFor]
				this.modalContext = 'info' // for assignItem
			} else {
				if (!this.filters[listFor]) { return false }
				searchTerm = this.filters[listFor]
				this.modalContext = 'filter' // for assignItem
			}
			if (!searchTerm) { return false }
			let postData = { search_term: searchTerm }
			let getList = listFor + 's'
			if (listFor == 'category') {
				getList = 'categories'
				postData.department_id = this.productDetail.info.department_id
			}
			let returnList = getList
			this.modalForList = listFor
			this.apiCall({ destination: 'get_list_' + getList, data: postData }).then(obj => {
				if (obj.status == 'success') {
					if (obj.status == 'error') {
						this.modalMessage = obj.message
						this.showModal = true
					} else if (obj[returnList].length > 1) {
						this.modalMessage = ''
						this.modalList = obj[returnList]
						this.showModal = true
					} else if (obj[returnList].length == 1) {
						this.assignItem(obj[returnList][0], context)
					} else {
						this.modalMessage = 'No matching ' + getList + ' found'
						this.showModal = true
					}
				}
			}).catch(err => {
				console.log(err)
			})
		},
		assignItem(listItem) {
			if (this.modalContext == 'filter') {
				this.filters[this.modalForList + '_id'] = listItem[this.modalForList + '_id']
				this.filters[this.modalForList] = listItem.description
				this.filters.page = 1
				this.getList()
				//if (!this.filters.department_id && this.filters.manufacturer_id) {
				//	this.getListFilters()
				//}
			} else {
				this.productDetail.info[this.modalForList + '_id'] = listItem[this.modalForList + '_id']
				this.productDetail.info[this.modalForList] = listItem.description
			}
			this.showModal = false
			this.modalList = []
			this.modalTitle = ''
			this.modalForList = ''
			this.modalContext = ''
		},
		addToCart(item) {
			if (this.addingToCart) { return false }
			this.addingToCart = true
			item.adding_to_cart = true
			let addQuantity 
			if(item.cart_quantity !== undefined && item.cart_quantity !== null){
				addQuantity = parseInt(item.cart_quantity)
			} else {
				addQuantity = 1
			}
			this.apiCall({ destination: 'add_to_dealer_cart', data: { product_id: item.product_id, quantity: addQuantity } }).then(obj => {
				this.addingToCart = false
				if (obj.status == 'success') {
					this.addToCartMessage = 'Item added!'
					this.productDetail.info.in_cart = addQuantity
					this.productDetail.availability.in_cart = addQuantity
					this.reloadListAfterSave = true
					item.adding_to_cart = false
					item.in_cart = true
					setTimeout(() => { this.addToCartMessage = '' }, 1500)
				}
			}).catch(err => {
				console.log(err)
			})
		},
		getDetail(product) {
			let productId = product.product_id || product
			this.productDetail.product_id = productId
			if (product.description) {
				this.productDetail.description = product.description
			}
			for (let i = this.list.length - 1; i >= 0; i--) {
				if (this.list[i].product_id == this.productDetail.product_id) {
					this.productDetailListIndex = i
					break;
				}
			}
			this.showDetail = true
			this.fetchDetailTab('info')
			this.getInventoryReasonCodes()
		},
		getPreviousItem() {
			if (this.productDetailListIndex == 0) { return }
			this.getDetail(this.list[this.productDetailListIndex - 1])
		},
		getNextItem() {
			if (this.productDetailListIndex == this.list.length - 1) { return }
			this.getDetail(this.list[this.productDetailListIndex + 1])
		},
		getInventoryReasonCodes() {
			if (this.inventoryReasonCodes.length == 0) {
				this.apiCall({ destination: 'get_list_inventory_reason_codes' }).then(obj => {
					this.inventoryReasonCodes = obj.list
				}).catch(err => {
					console.log(err)
				})
			}
		},
		getProductTypes() {
			if (this.productTypes.length == 0) {
				this.apiCall({ destination: 'get_list_product_types' }).then(obj => {
					this.productTypes = obj.product_types
				}).catch(err => {
					console.log(err)
				})
			}
		},
		addProduct() {
			this.resetProductDetail()
			this.productDetail.info.client_id = this.client_id
			this.productDetail.product_id = 'new'
			this.productDetail.info.description = 'New Product'
			this.productDetail.info.image_src = "https://cds-media.s3-us-west-2.amazonaws.com/image-unavailable.png"
			this.productDetail.info.image_src_large = "https://cds-media.s3-us-west-2.amazonaws.com/image-unavailable.png"
			this.showDetailTab = 'info'
			this.showDetail = true
			this.getInventoryReasonCodes()
			if (this.productTypes.length == 0) {
				this.getProductTypes()
			}
		},
		fetchDetailTab(detailTab, forceReload = false) {
			if (this.productDetail.product_id == 'new') { return }
			this.showDetailTab = detailTab
			// if print_tags and not serializable, we don't need to call the API for serial numbers
			if (detailTab == 'print_tags' && !this.productDetail.info.serializable) {
				return
			}
			// skip API call if this section already populated
			if (!forceReload && this.productDetail[detailTab]['product_id'] == this.productDetail.product_id) { return }
			this.loading = true
			this.apiCall({ destination: 'get_item_product_' + detailTab, data: { product_id: this.productDetail.product_id } }).then(obj => {
				if (obj.status == 'success') {
					this.client_id = obj.client_id // to determine userCanEdit
					this.productDetail[detailTab] = obj.product
					switch(detailTab) {
						case 'info':
							if (this.productDetail.info.product_type_code == 'CLASSES') {
								this.showClassAlert = true
							}
							if (this.productTypes.length == 0) {
								this.getProductTypes()
							}
							if (this.productDetail.info.department_id) {
								this.getCategories(this.productDetail.info.department_id)
							}
							this.gunBrokerEnabled = obj.gunbroker_enabled
						case 'availability':
							break;
						case 'print_tags':
							break;
						case 'specifications':
							this.product_descriptors = obj.product_descriptors;
							if (this.userCanEdit) {
								this.product_descriptors.unshift({'product_descriptor_id': '', 'description': 'Select...'})
								if (this.productDetail.specifications.descriptions.length == 0) {
									this.productDetail.specifications.descriptions.push({'product_descriptor_id': '', 'content': ''})
								}
							}
							break;
						case 'shipping':
							this.product_notices_system = obj.product_notices_system
							this.product_notices_client = obj.product_notices_client
							break;
						case 'sales':
							this.sales_history = obj.sales_history
							break;
						case 'change_log':
							this.change_log = obj.list
							break;
					}
				}
				this.loading = false
			}).catch(err => {
				console.log(err)
			})
		},
		async checkGunBrokerCredentials() {
			if (!this.gunBrokerUsername || !this.gunBrokerPassword) {
				this.apiCall({ destination: "gun_broker_get_user_credentials" })
				.then((obj) => {
					if (obj.status == "success" && obj.username && obj.password) {
						this.gunBrokerUsername = obj.username;
						this.newGunBrokerUsername = obj.username;
						this.gunBrokerPassword = obj.password;
						this.newGunBrokerPassword = obj.password;
						this.fetchGunBrokerDetails();
					} else {
						this.mustEnterGunBrokerCredentials = true;
						this.showGunBrokerConnectionModal = true;
					}
				})
				.catch((err) => {
					console.error("Error fetching GunBroker credentials:", err);
					this.mustEnterGunBrokerCredentials = true;
					this.showGunBrokerConnectionModal = true;
				});
			} else {
				this.fetchGunBrokerDetails();
			}
		},
		async fetchGunBrokerDetails() {
			if (this.productDetail.product_id == 'new') { return }
			this.showDetailTab = 'gun_broker'
			this.showGBItemDetail = false
			this.loading = true
			
			await this.apiCall({ destination: 'get_item_product_availability', data: { product_id: this.productDetail.product_id } }).then(obj => {
				if (obj.status == 'success') {
					this.productDetail.availability = obj.product
				}
			}).catch(err => {
				console.log(err)
				this.loading = false
			})
			
			await this.apiCall({ destination: 'gun_broker_get_item_from_db', data: { product_id: this.productDetail.product_id } }).then(obj => {
				if (obj.status == 'success') {
					this.loadTemplates();
					if (!obj.item.ShippingClassCosts) {
						obj.item.ShippingClassCosts = {};
					}
					if (!obj.item.ItemID) {
						this.assignProductToGBItem()
					} else {
						this.gunBrokerItemDetail = JSON.parse(JSON.stringify(obj.item)); // deep copy						
						this.productClientDataId = obj.product_client_data_id;

						this.gunBrokerQuantityToAllocate = obj.item.QuantityAllocated || 0
						this.gunBrokerAllocateProduct = this.gunBrokerQuantityToAllocate > 0;

						this.gunBrokerPictureURLs = this.gunBrokerItemDetail.PictureURLs.map((url, index) => {
							return {
								image_src_large: url,
								image_src: url,
								sort_order: index + 1,
								inactive: 0,
								product_id: this.productDetail.product_id
							}
						}) || [];
						
						this.gunBrokerItemDetailCopy = JSON.parse(JSON.stringify(this.gunBrokerItemDetail)) // deep copy for reset
						this.gbListingType = this.gbListingTypeLabel;

						if (obj.relisted) {
							this.messageStatus = null;
							this.showSaving = true;
							this.savingMessage = 'The original listing has ended and been relisted on GunBroker. We have loaded the new listing details here.';
						}
						if (obj.item.meta) this.gunBrokerItemDetailMeta = obj.item.meta
						this.gunBrokerScheduledStartingDate = this.gunBrokerItemDetailMeta?.ScheduleStartingDate ? moment.utc(this.gunBrokerItemDetail.StartingDate).tz("America/New_York") : null;

						this.gunBrokerItemDetailMeta.ExcludeStates = !!this.gunBrokerItemDetail.ExcludeStates
					}
				} else {
					console.log('No GunBroker item found for this product.');
				}
			}).catch(err => {
				console.log(err)
			}).finally(() => {
				this.loading = false
			})
			this.selectedGunBrokerCategories = []
			if (!this.gunBrokerCategories.length) {
				this.fetchGunBrokerCategories()
			}
			this.fetchGunBrokerStandardText()
			this.loading = false
		},
		fetchGunBrokerCategories(category = null, level = 0) {
			this.loadingGunBrokerCategories = true
			if (category) {
				this.gunBrokerCategories.splice(level, 9999) // remove all categories below this level
				this.selectedGunBrokerCategories.splice(level, 9999)
			}
			if (!category) {
				this.apiCall({ destination: 'gun_broker_get_categories' }).then(obj => {
					if (obj.status == 'success') {
						const categories = obj.categories.map(category => {
							return {
								categoryID: category.categoryID,
								categoryName: category.categoryName,
								canContainItems: category.canContainItems,
								hasSubCategories: category.hasSubCategories,
								subCategories: category.subCategories || []
							}
						})
						this.$set(this, 'gunBrokerCategories', [...this.gunBrokerCategories, categories])
					} else {
						this.showSaving = true
						this.messageStatus = 'error'
						this.savingMessage = obj.message + '<br>Check your GunBroker username and password in Merchant Settings.'
					}
				}).catch(err => {
					console.log(err)
				}).finally(() => {
					this.loadingGunBrokerCategories = false
				})
			} else if (category.canContainItems === false || category.hasSubCategories === true) {
				this.selectedGunBrokerCategories.push(category)
				this.apiCall({ destination: 'gun_broker_get_category_by_id', data: { category_id: category.categoryID } }).then(obj => {
					if (obj.status == 'success') {
						this.gunBrokerCategories[level] = obj.categories.map(category => {
							return {
								categoryID: category.categoryId,
								categoryName: category.categoryName,
								canContainItems: category.canContainItems,
								hasSubCategories: category.hasSubCategories,
								subCategories: category.subCategories || []
							}
						})
					}
				}).catch(err => {
					console.log(err)
				}).finally(() => {
					this.loadingGunBrokerCategories = false
				})
			} else {
				this.loadingGunBrokerCategories = false
			}
		},
		fetchGunBrokerStandardText() {
			this.apiCall({ destination: 'gun_broker_get_standard_text' }).then(obj => {
				if (obj.status == 'success') {
					this.gunBrokerStandardTextList = obj.standard_text || '';
				}
			}).catch(err => {
				console.log(err)
			})
		},
		addGunBrokerExcludedState(event) {
			if (!event) return;
			this.gunBrokerExcludedStates = [...this.gunBrokerExcludedStates, event];
		},
		removeGunBrokerExcludedState(index) {
			const next = this.gunBrokerExcludedStates.slice();
			next.splice(index, 1);
			this.gunBrokerExcludedStates = next; // triggers setter
		},
		resetGunBrokerListingOptions() {
			this.gunBrokerItemDetail.ListingDuration = null;
			this.gunBrokerItemDetail.ReservePrice = null;
			this.gunBrokerItemDetail.StartingBid = null;
			this.gunBrokerItemDetail.BuyNowPrice = null;
			this.gunBrokerItemDetail.FixedPrice = null;
			this.gunBrokerItemDetail.Quantity = null;
			this.gunBrokerItemDetail.CanOffer = null;
			this.gunBrokerItemDetail.AutoAcceptPrice = null;
			this.gunBrokerItemDetail.AutoRejectPrice = null;
			this.gunBrokerItemDetail.AutoRelist = 1;
			this.gunBrokerItemDetail.AutoRelistFixedCount = null;
		},
		imagesUpdated(images) {
			this.productDetail.info.product_images = images
			this.gunBrokerPictureURLs = images;
			this.reloadListAfterSave = true
		},
		assignProductToGBItem() {
			if (this.productDetail.product_id == 'new') { return }
			console.log('Assigning product', this.productDetail);
			this.gunBrokerItemDetail.SKU = this.productDetail.info.sku || ''
			this.gunBrokerItemDetail.Title = this.productDetail.info.description.substring(0, 75)
			this.gunBrokerItemDetail.Description = this.productDetail.info.detailed_description || ''
			this.gunBrokerItemDetail.UPC = this.productDetail.info.upc || ''
			this.gunBrokerItemDetail.IsFFLRequired = this.productDetail.info.serializable ? true : false
			this.gunBrokerPictureURLs = this.productDetail.info.product_images || [];
			this.gunBrokerItemDetail.Weight = parseInt(this.productDetail.info.ship_weight) || null;
			this.gunBrokerItemDetail.WeightUnits = 'lbs';
			this.gunBrokerItemDetail.PostalCode = this.getClient.zip_code || '';
			this.gunBrokerItemDetail.CountryCode = this.getClient.country_code || 'US';
			this.gunBrokerItemDetail.PremiumFeatures = {
				TitleColor: '',
				SubTitle: '',
				ScheduledStartingDate: '',
				IsShowCaseItem: false,
				IsFeaturedItem: false
			};
			this.gunBrokerItemDetailCopy = JSON.parse(JSON.stringify(this.gunBrokerItemDetail));
		},
		selectTemplate(templateId) {
			this.selectedTemplateId = templateId
			const template = this.templateMap[templateId];
			if (template.settings) {
				Object.keys(template.settings).forEach(key => {
					if (key == 'ExcludeStates') {
						this.gunBrokerItemDetailMeta.ExcludeStates = template.settings[key].length > 0;
						this.gunBrokerItemDetail.ExcludeStates = template.settings[key];
					// } else if (key == 'ExcludeStatesList') {
					// 	this.gunBrokerItemDetail.ExcludeStates = template.settings[key];
					} else {
						this.gunBrokerItemDetail[key] = template.settings[key];
					}
				});
			}
		},
		deleteTemplate(templateId) {
			this.showSaving = true;
			this.saveMessage = 'Deleting template...';
			this.messageStatus = null;
			this.messageTimeout = 0;
			this.apiCall({ destination: 'delete_product_listing_template', data: { product_listing_template_id: templateId } }).then(obj => {
				this.messageStatus = obj.status;
				if (obj.status == 'success') {
					this.saveMessage = '';
					this.showSaving = false;
					this.loadTemplates();
					if (this.selectedTemplateId == templateId) {
						this.selectedTemplateId = null;
					}
				} else {
					this.saveMessage = obj.message || 'Error deleting template.'
				}
			}).catch(err => {
				console.log(err)
			});
		},
		toggleShippingClass(id) {
			const current = this.gunBrokerItemDetail.ShippingClassesSupported[id];
			this.$set(this.gunBrokerItemDetail.ShippingClassesSupported, id, !current);
		},
		togglePaymentMethod(id) {
			const current = this.gunBrokerItemDetail.PaymentMethods[id];
			this.$set(this.gunBrokerItemDetail.PaymentMethods, id, !current);
		},
		listGBItem() {
			this.gunBrokerItemDetail.CategoryID = this.gunBrokerItemDetail.CategoryID ?? this.gunBrokerCategoryID

			this.messageStatus = null;
			this.messageTimeout = 0;
			this.showSaving = true;
			this.loading = true;
			this.savingMessage = 'Listing your item on GunBroker.'

			if (!this.validateGunBrokerItem) {
				this.loading = false;
				//this.messageTimeout = 5000;
				this.savingMessage = 'Please fill in all required fields<br>'
				// add gunBrokerInvalidFields to message
				this.savingMessage += '(' + this.gunBrokerInvalidFields.join(', ') + ')';
				this.messageStatus = 'invalid'
				return;
			}
			this.gunBrokerItemDetail.PictureURLs = this.gunBrokerPictureURLs
				.sort((a, b) => a.sort_order - b.sort_order)
				.map(image => image.image_src_large) || [];

			this.gunBrokerQuantityToAllocate = this.gunBrokerAllocateProduct ? this.gunBrokerQuantityToAllocate : 0;
			
			if (!this.gunBrokerItemDetail.PremiumFeatures?.ScheduledStartingDate?.length) {
				delete this.gunBrokerItemDetail.PremiumFeatures.ScheduledStartingDate;
			}
			if (!this.gunBrokerItemDetail.PremiumFeatures?.TitleColor?.length) {
				delete this.gunBrokerItemDetail.PremiumFeatures.TitleColor;
			}
			if (!this.gunBrokerItemDetail.PremiumFeatures?.SubTitle?.length) {
				delete this.gunBrokerItemDetail.PremiumFeatures.SubTitle;
			}
			if (!this.gunBrokerItemDetail.PremiumFeatures?.IsShowCaseItem) {
				this.gunBrokerItemDetail.PremiumFeatures.IsShowCaseItem = false;
			} else {
				this.gunBrokerItemDetail.PremiumFeatures.IsShowCaseItem = true;
			}
			if (!this.gunBrokerItemDetail.PremiumFeatures?.IsFeaturedItem) {
				this.gunBrokerItemDetail.PremiumFeatures.IsFeaturedItem = false;
			} else {
				this.gunBrokerItemDetail.PremiumFeatures.IsFeaturedItem = true;
			}

			this.apiCall({ destination: 'gun_broker_list_item', data: { product_id: this.productDetail.product_id, item: this.gunBrokerItemDetail, meta: this.gunBrokerItemDetailMeta, allocated: this.gunBrokerQuantityToAllocate } }).then(obj => {
				if (obj.status == 'success') {
					this.savingMessage = 'Item listed successfully!'
					if (!obj.item.ShippingClassCosts) {
						obj.item.ShippingClassCosts = {};
					}
					this.$set(this, 'gunBrokerItemDetail', obj.item);
					this.productClientDataId = obj.product_client_data_id;
					this.messageTimeout = 3000;
					this.gunBrokerItemDetailCopy = JSON.parse(JSON.stringify(this.gunBrokerItemDetail)) // deep copy for reset
				} else {
					throw new Error(obj.message || 'Error listing item on GunBroker.')
				}
			}).catch(err => {
				console.log(err)
				this.savingMessage = 'Error listing item on GunBroker: ' + err.message
				this.messageStatus = 'error';
			}).finally(() => {
				this.loading = false;
			});
		},
		updateGBItem() {

			if (!this.canEditGunBrokerItem || !this.getGunBrokerItemDetailChangedItems) {
				return;
			}

			this.messageStatus = null;
			this.showSaving = true;
			this.loading = true;
			this.savingMessage = 'Updating your item on GunBroker.'

			if (!this.validateGunBrokerItem) {
				this.loading = false;
				this.messageTimeout = 5000;
				this.savingMessage = 'Please fill in all required fields.'
				this.messageStatus = 'invalid'
				return;
			}
			
			this.loading = true
			this.gunBrokerItemDetail.PictureURLs = this.gunBrokerPictureURLs
				.sort((a, b) => a.sort_order - b.sort_order)
				.map(image => image.image_src_large) || [];
			
			const changes = this.getGunBrokerItemDetailChangedItems;
			if (!changes) {
				this.loading = false;
				return;
			}
			this.gunBrokerQuantityToAllocate = this.gunBrokerAllocateProduct ? this.gunBrokerQuantityToAllocate : 0;
			changes.ItemCharacteristics = [
				{
					characteristicName: "Caliber",
					characteristicValue: [
						".45 ACP"
					]
				},
				{
					characteristicName: "manufacturerName",
					characteristicValue: [
						"Other Manufacturer"
					]
				},
				{
					characteristicName: "model",
					characteristicValue: [
						"Other Model"
					]
				}
			];
			this.apiCall({ destination: 'gun_broker_update_item', data: { product_client_data_id: this.productClientDataId, product_id: this.productDetail.product_id, item: this.gunBrokerItemDetail, changes, allocated: this.gunBrokerQuantityToAllocate } }).then(obj => {
				if (obj.status == 'success') {
					this.savingMessage = 'Item updated successfully!'
					this.messageTimeout = 3000;
					this.loading = false;
					this.gunBrokerItemDetailCopy = JSON.parse(JSON.stringify(this.gunBrokerItemDetail))
				} else {
					throw new Error(obj.message || 'Error updating item on GunBroker.');
				}
			}).catch(err => {
				console.log(err)
				this.savingMessage = 'Error updating item on GunBroker: ' + err.message
				this.messageStatus = 'error';
			}).finally(() => {
				this.loading = false;
			});
		},
		endGBItem() {
			this.confirmEndGBItem = false;
			this.showSaving = true;
			this.savingMessage = 'Ending your listing on GunBroker.'
			this.apiCall({ destination: 'gun_broker_end_item', data: { product_id: this.productDetail.product_id, item_id: this.gunBrokerItemDetail.ItemID } }).then(obj => {
				if (obj.status == 'success') {
					this.fetchGunBrokerDetails()
					this.savingMessage = 'Listing ended successfully.'
				}
			}).finally(() => {
				this.loading = false;
				this.messageTimeout = 3000;
			});
		},
		validateGunBrokerQuantityToAllocate() {
			if (this.gunBrokerQuantityToAllocate < 1) {
				this.gunBrokerQuantityToAllocate = 1;
			} else if (this.gunBrokerQuantityToAllocate > this.productDetail.availability.on_hand) {
				this.gunBrokerQuantityToAllocate = this.productDetail.availability.on_hand;
			}
		},
		validateGunBrokerAutoRelistFixedCount() {
			if (this.gunBrokerItemDetail.AutoRelistFixedCount < 1) {
				this.gunBrokerItemDetail.AutoRelistFixedCount = 1;
			} else if (!this.gunBrokerAllocateProduct) {
				return;
			} else if (this.gunBrokerItemDetail.AutoRelistFixedCount > this.gunBrokerQuantityToAllocate) {
				this.gunBrokerItemDetail.AutoRelistFixedCount = this.gunBrokerQuantityToAllocate;
			}
		},
		handleClickAutoRelist() {
			// This function only handles auto relist for fixed price listings
			this.gunBrokerItemDetail.AutoRelistFixedCount = null; // Reset fixed count when toggling auto relist
			this.gunBrokerItemDetail.AutoRelist = this.gunBrokerItemDetail.AutoRelist === 1 ? 4 : 1; // Toggle between 'Auto Relist' and 'No Auto Relist'
		},
		resetGunBrokerItem(reListing = false) {
			// Have to do this before deleting for reactivity
			this.gunBrokerItemDetail['ItemID'] = null;
			this.gunBrokerItemDetail['EndingDate'] = null;
			this.gunBrokerItemDetail['HasWinningBid'] = null;
			this.gunBrokerItemDetail['Bids'] = 0;
			
			if (!reListing) {
				this.gbListingType = 'Standard Auction';
				this.gunBrokerItemDetail['CategoryID'] = null;
				this.gunBrokerItemDetail['CategoryName'] = null;
				this.gunBrokerItemDetail['Weight'] = null;
				this.gunBrokerItemDetail['WeightUnit'] = 1;
				this.gunBrokerItemDetailMeta = {
					ScheduleStartingDate: false,
					SubTitle: null,
					TitleColor: null,
					ExcludeStates: false
				};
				for (const key in this.gunBrokerItemDetail) {
					if (!GUN_BROKER_ITEM.hasOwnProperty(key)) {
						delete this.gunBrokerItemDetail[key];
					} else {
						this.gunBrokerItemDetail[key] = GUN_BROKER_ITEM[key];
					}
				}
				this.gunBrokerCategories = [];
				this.selectedGunBrokerCategories = [];
				this.gunBrokerPictureURLs = this.productDetail.info.product_images || [];
			}
			
			this.gunBrokerItemDetailCopy = JSON.parse(JSON.stringify(this.gunBrokerItemDetail)) // deep copy for reset
		},
		updateGunBrokerProductAllocation() {
			if (this.gunBrokerItemHasSold && this.gunBrokerItemHasEnded && this.gunBrokerItemDetail.Bids) return;

			this.showSaving = true;
			this.savingMessage = 'Updating product allocation.'
			this.gunBrokerQuantityToAllocate = this.gunBrokerAllocateProduct ? this.gunBrokerQuantityToAllocate : 0;
			this.apiCall({ destination: 'gun_broker_update_product_allocation', data: { product_id: this.productDetail.product_id, allocated: this.gunBrokerQuantityToAllocate, quantity: this.gunBrokerItemDetail.Quantity } }).then(obj => {
				if (obj.status !== 'success') {
					this.gunBrokerAllocateProduct = !this.gunBrokerAllocateProduct;
					this.savingMessage = obj.message || 'Error updating product allocation.'
					this.messageStatus = 'error';
				} else {
					this.savingMessage = 'Product allocation updated.'
					this.messageTimeout = 3000;
					this.messageStatus = 'success';
				}
			}).catch(err => {
				this.savingMessage = obj.message || 'Error updating product allocation.'
				this.messageStatus = 'error';
			});
		},
		goToSalesHistoryPage(page) {
			this.loading = true
			this.apiCall({ destination: 'get_item_product_sales', data: { product_id: this.productDetail.product_id, page: page } }).then(obj => {
				if (obj.status == 'success') {
					this.sales_history = obj.sales_history
					this.productDetail.sales.current_page = page
				}
				this.loading = false
			}).catch(err => {
				console.log(err)
			})
		},
		goToChangeLogPage(page) {
			this.loading = true
			this.apiCall({ destination: 'get_item_product_change_log', data: { product_id: this.productDetail.product_id, page: page } }).then(obj => {
				if (obj.status == 'success') {
					this.change_log = obj.list
					this.productDetail.change_log.current_page = page
				}
				this.loading = false
			}).catch(err => {
				console.log(err)
			})
		},
		getChangeLogDetail(log) {
			this.showChangeLogModal = true
			this.changeLogDetail = log // TOOD: call API action
		},
		calculateProfit() {
			if (this.productDetail.availability.cost > 0) {
				if (this.productDetail.availability.web_price > 0) {
					this.productDetail.availability.web_profit = (100 * (1 - (this.productDetail.availability.cost / this.productDetail.availability.web_price))).toFixed(1)
				}
				if (this.productDetail.availability.price > 0) {
					this.productDetail.availability.pos_profit = (100 * (1 - (this.productDetail.availability.cost / this.productDetail.availability.price))).toFixed(1)
				}
			}
		},
		confirmHideStoreProducts() {
			if (!this.usesWebsiteBuilder) { return }
			this.confirmModalRequireReason = false
			this.confirmModalRequireManager = true
			this.confirmModalMessage = 'Confirm ' + (this.hideStoreLocation ? 'Unhide' : 'Hide') + ' all store products'
			this.confirmModalAction = 'save_hide_store_products'
			this.showConfirmModal = true
		},
		saveHideStoreProducts() {
			if (this.saving.hide_store_products) { return }
			this.saving.hide_store_products = true
			this.apiCall({ destination: 'save_hide_store_products', data: { manager_code: this.managerCode } }).then(obj => {
				this.saving.hide_store_products = false
				this.confirmModalStatusMessage = obj.message || ''
				if (obj.status == 'success') {
					this.hideStoreLocation = obj.hide_store_location
					this.resetConfirmModal()
				}
			}).catch(err => {
				console.log(err)
			})
		},
		confirmPriceChange() {
			if (this.neverReceived) { return }
			if (this.productDetail.availability.new_prices) {
				this.saveProductInfo('availability', 'prices')
			} else {
				this.confirmModalRequireReason = true
				this.confirmModalRequireManager = this.getUser.user_type_code != 'MANAGER' && !this.getUser.administrator_flag
				this.confirmModalMessage = 'Confirm save prices'
				this.confirmModalAction = 'save_prices'
				this.showConfirmModal = true
			}
		},
		resyncAvailability() {
			this.productDetail.availability.on_hand = this.productDetail.availability.serial_numbers.length
			this.confirmAvailabilityChange(true)
		},
		confirmAvailabilityChange(forceUpdate) {
			if (!forceUpdate && (this.productDetail.info.serializable || this.neverReceived)) { return }
			this.confirmModalRequireReason = true
			this.confirmModalRequireManager = this.getUser.user_type_code != 'MANAGER' && !this.getUser.administrator_flag
			this.confirmModalMessage = 'Confirm save prices & availability'
			this.confirmModalAction = 'save_prices_availability'
			this.showConfirmModal = true
		},
		confirmLimitsChange() {
			if (this.getUser.user_type_code.indexOf('MANAGER') > -1 || this.getUser.administrator_flag) {
				this.saveProductInfo('availability', 'limits')
			} else {
				this.confirmModalRequireReason = true
				this.confirmModalRequireManager = true
				this.confirmModalMessage = 'Confirm save product limits'
				this.confirmModalAction = 'save_limits'
				this.showConfirmModal = true
			}
		},
		confirmSaveReorderActions() {
			if (!this.productDetail.availability.reorder_point || !this.productDetail.availability.reorder_point) {
				return
			}
			if (this.getUser.user_type_code.indexOf('MANAGER') > -1 || this.getUser.administrator_flag) {
				this.saveProductInfo('availability', 'reorder_actions')
			} else {
				this.confirmModalRequireReason = false
				this.confirmModalRequireManager = true
				this.confirmModalMessage = 'Confirm save reorder actions'
				this.confirmModalAction = 'save_reorder_actions'
				this.showConfirmModal = true
			}
		},
		resetConfirmModal() {
			this.showConfirmModal = false
			this.confirmModalRequireReason = false
			this.confirmModalRequireManager = false
			this.confirmModalMessage = ''
			this.confirmModalAction = ''
			this.confirmModalItem = ''
			this.confirmModalStatusMessage = ''
			this.inventoryReasonCodeId = ''
			this.managerCode = ''
		},
		saveProductInfo(section, action) {
			var doAction = action || section
			// prevent save if already saving
			if (this.saving[doAction]) { return }

			// prevent save info for system items
			if (section == 'info' && !this.userCanEdit) { return }

			// prevent save if required info is missing
			if (this.confirmModalRequireReason && !this.inventoryReasonCodeId) { return }
			if (this.confirmModalRequireManager && !this.managerCode) { return }
			if (section == 'specifications') {
				if (!this.userCanEdit) { return }
				let hasContent = 0
				let start = this.productDetail.specifications.descriptions.length - 1
				for (let i = this.productDetail.specifications.descriptions.length - 1; i >= 0; i--) {
					if (this.productDetail.specifications.descriptions[i].content) {
						hasContent++
					} else {
						this.productDetail.specifications.descriptions.splice(i,1)
					}
				}
				if (this.productDetail.specifications.descriptions.length == 0) {
					this.productDetail.specifications.descriptions.push({'product_descriptor_id': '', 'content': ''})
				}
			}
			if (section == 'shipping' && !this.userCanEdit) { return }
			let postObject = JSON.parse(JSON.stringify(this.productDetail[section]))
			postObject.inventory_reason_code_id = this.inventoryReasonCodeId
			postObject.manager_code = this.managerCode
			postObject.product_id = this.productDetail.product_id // regardless of section productDetail will always have the current product_id
			if (section == 'info') {
				// prevent save if user entered a caliber or manufacturer but didn't complete the selection of id
				if (this.productDetail.info.caliber && !this.productDetail.info.caliber_id) { return}
				if (this.productDetail.info.manufacturer && !this.productDetail.info.manufacturer_id) { return }
			}
			this.saving[doAction] = true
			this.saveMessage[doAction] = 'Saving'
			this.showSaving = true
			this.savingMessage = 'Saving product ' + doAction + '...'
			this.messageStatus = ''
			this.apiCall({ destination: 'save_item_product_' + doAction, data: postObject }).then(obj => {
				this.messageStatus = obj.status
				this.saving[doAction] = false
				this.saveMessage[doAction] = obj.message || ''
				setTimeout(() => { 
					this.saveMessage[doAction] = '' 
					this.savingMessage = obj.message || ''
					this.showSaving = false
				}, 1500)
				if (obj.status == 'success') {
					this.savingMessage = 'Product ' + doAction + ' saved!'
					if (obj.product_id) {
						this.productDetail.product_id = obj.product_id
					}
					if (section == 'info' && obj.product.preview_link) {
						this.productDetail.info.preview_link = obj.product.preview_link
					}
					if (section == 'shipping'){
						this.apiCall({ destination: 'get_item_product_shipping', data: {product_id: this.productDetail.product_id} }).then(result => {
							if(result.status && result.status === 'success' && result.product) {
								//Refresh product detail to have updated shipping values and not old ones from fetch
								this.productDetail.info.ship_weight = result.product.ship_weight,
								this.productDetail.info.ship_length = result.product.ship_length,
								this.productDetail.info.ship_width = result.product.ship_width,
								this.productDetail.info.ship_height = result.product.ship_height,
								this.productDetail.info.is_hazardous = result.product.is_hazardous

							}
						}).catch(err => {
							console.log('Failed to refresh shipping information. Please refresh browser.', err)
						})
					}
					this.resetConfirmModal()
					this.reloadListAfterSave = true
				} else {
					this.confirmModalStatusMessage = obj.message
				}
			}).catch(err => {
				console.log(err)
			})
		},
		confirmDeleteProduct() {
			if (this.productDetail.info.on_hand > 0) {
				this.confirmModalRequireReason = false
				this.confirmModalRequireManager = false
				this.confirmModalMessage = 'Not Allowed'
				this.confirmModalStatusMessage = 'Deactivate not allowed for items with inventory.'
			} else {
				this.confirmModalRequireReason = !this.getAdministratorFlag
				this.confirmModalRequireManager = !this.getAdministratorFlag && (this.getUser.user_type_code != 'MANAGER' || !this.getUser.administrator_flag)
				this.confirmModalMessage = 'Confirm ' + (this.productDetail.info.inactive ? 're' : 'de') + 'activate this product'
				this.confirmModalAction = 'save_delete'
			}
			this.showConfirmModal = true
		},
		deleteProduct() {
			if (this.saving.set_delete) { return }
			if (!this.getAdministratorFlag && this.productDetail.info.client_id != this.client_id) { return }
			this.saving.set_delete = true
			this.apiCall({ destination: 'save_item_product_delete', data: { product_id: this.productDetail.info.product_id, inactive: this.productDetail.info.inactive, inventory_reason_code_id: this.inventoryReasonCodeId, manager_code: this.managerCode } }).then(obj => {
				this.saving.set_delete = false
				this.resetConfirmModal()
				this.getList()
			}).catch(err => {
				console.log(err)
			})
		},
		saveProductNotice(productNotice, action) {
			if (action != 'delete' && !productNotice.description && !productNotice.notice) { return }
			if (this.saving.product_notice) { return }
			let postObject = JSON.parse(JSON.stringify(productNotice))
			postObject.action = action
			postObject.product_id = this.productDetail.info.product_id
			// slight delay to let the dom catch up
			setTimeout(() => { 
				if (action == 'activate') {
					postObject.active = postObject.active ? false : true // reverse current active state of object
				}
			}, 1500)
			this.apiCall({ destination: 'save_item_product_notice', data: postObject }).then(obj => {
				this.saving.product_notice = false
				if (action == 'new') {
					let newProductNotice = JSON.parse(JSON.stringify(productNotice))
					newProductNotice.product_notice_id = obj.product_notice_id
					newProductNotice.active = true
					this.product_notices_client.push(newProductNotice)
					productNotice.description = ''
					productNotice.notice = ''
				}
			}).catch(err => {
				console.log(err)
			})
		},
		toggleValue(which) {
			if (this.userCanEdit) {
				this.productDetail[this.showDetailTab][which] = !this.productDetail[this.showDetailTab][which]
			}
		},
		confirmRemoveSerialNumber(serialNumber) {
			this.confirmModalRequireReason = true
			this.confirmModalRequireManager = true
			this.confirmModalMessage = 'Confirm remove serial number'
			this.confirmModalAction = 'remove_serial_number'
			this.confirmModalItem = serialNumber
			this.showConfirmModal = true
		},
		removeSerialNumber(serialNumber) {
			if (this.saving.remove_serial_number) { return }
			if (this.confirmModalRequireReason && !this.inventoryReasonCodeId) { return }
			if (this.confirmModalRequireManager && !this.managerCode) { return }
			this.saving.remove_serial_number = true
			let postData = {
				product_id: this.productDetail.info.product_id,
				serial_number: serialNumber,
				inventory_reason_code_id: this.inventoryReasonCodeId,
				manager_code: this.managerCode
			}
			this.apiCall({ destination: 'save_remove_serial_number', data: postData }).then(obj => {
				this.saving.remove_serial_number = false
				this.confirmModalStatusMessage = obj.message
				if (obj.status == 'success') {
					this.resetConfirmModal()
					this.fetchDetailTab(this.showDetailTab, true)
				}
			}).catch(err => {
				console.log(err)
			})
		},
		updateNotTaxable() {
			if (this.updatingNotTaxable) { return }
			this.updatingNotTaxable = true
			this.apiCall({ destination: 'save_item_product_not_taxable', data: { product_id: this.productDetail.info.product_id, product_client_id: this.productDetail.info.client_id } }).then(obj => {
				this.updatingNotTaxable = false
				this.confirmSetNotTaxable = false
			}).catch(err => {
				console.log(err)
			})
		},
		cancelUpdateNotTaxable() {
			this.confirmSetNotTaxable = false
			if (this.productDetail.info.not_taxable) {
				this.productDetail.info.not_taxable = 0
			} else {
				this.productDetail.info.not_taxable = 1
			}
		},
		backToList() {
			this.showDetail = false
			this.resetProductDetail()
			if (this.reloadListAfterSave) {
				this.getList()
			}
		},
		goToOrder(order) {
			this.$router.push('/orders-sales/orders/detail/' + order.order_id)
		},
		manageOverrides(overrideFor) {
			this.overridePrice = overrideFor
			// spread operator ... iterates objects 
			this.overridePrice = {
				...overrideFor,
				...this.productDetail.info
			}
			this.showPriceOverride = true
		},
		finishedPriceOverride(updateRequired) {
			if (updateRequired) {
				this.fetchDetailTab('availability', true)
			}
			this.showPriceOverride = false
		},
		requestProductEdit() {
			this.$router.push('/help-center/support-tickets-detail/new?topic=Please Edit ' + this.productDetail.info.upc + '&priority=low&tag=product&content=Please edit the following info for UPC ' + this.productDetail.info.upc + '...')
		},
		setSplitItem(distributorItem) {
			this.splitDistributorItem = distributorItem
			this.confirmSplitItem = true
		},
		doSplitItem() {
			if (!this.getAdministratorFlag) { return }
			if (this.doingSplit) { return }
			this.doingSplit = true
			this.apiCall({ destination: 'save_item_split_distributor', data: { product_id: this.productDetail.info.product_id, distributor_id: this.splitDistributorItem.distributor_id } }).then(obj => {
				this.doingSplit = false
				this.confirmSplitItem = false
				this.reloadListAfterSave = true
				this.fetchDetailTab('availability', true)
			}).catch(err => {
				console.log(err)
			})
		},
		async loadTemplates() {
            await this.apiCall({ destination: 'get_list_product_listing_templates', data: { group_code: this.templateGroupCode }}).then(response => {
                this.templates = response.templates || [];
            }).catch(error => {
                console.error("Error loading templates:", error);
            });
        },
        saveTemplate() {
			if (this.showSaving) { return; }
            if (!this.newTemplateName && !this.selectedTemplateId) {
				console.log("Template name is required.");
                return;
            }
			this.showSaving = true;
			this.saveMessage = 'Saving template...';
			this.messageStatus = null;
			this.messageTimeout = 0;
            this.apiCall({ destination: 'save_product_listing_template', data: {
                product_listing_template_id: this.newTemplateName ? null : this.selectedTemplateId,
                name: this.newTemplateName || this.templateMap[this.selectedTemplateId].settings.Name,
                settings: this.gunBrokerItemDetail,
				meta_data: this.gunBrokerItemDetailMeta,
                group_code: this.templateGroupCode
            }}).then(async (response) => {
				this.messageStatus = response.status;
				if (response.status == 'success') {
					this.saveMessage = '';
					this.showSaving = false;
					await this.loadTemplates();
					this.selectedTemplateId = response.product_listing_template_id;
					this.savingTemplate = false;
					this.newTemplateName = '';
				} else {
					this.saveMessage = 'Error saving template!';
					console.error("Error saving template:", response.message);
				}
            }).catch(error => {
                console.error("Error saving template:", error);
            });
        }
	}
}
</script>

<style lang="scss" scoped>
.templates {
	button:hover, .button:hover {
    	filter: brightness(108%) !important;
	}
}

.modal {
    .inner {
        max-height: 50em;
        max-width: 60em;
        .content {
            max-height: 25em;
        }
    }
}

.template-option {
	border: 1px solid grey;
	border-radius: 3px;
	padding: 8px;
	margin: 0 1px 0 0;
	cursor: pointer;
	i.fa-trash {
		display: none;
		float: right;
	}
	&.selected {
		border-color: #007bff;
		background-color: #d0e6ff;
	}
}
.template-option:hover {
	background-color: #efefef;
	i.fa-trash {
		display: block;
		margin: 0 0 0 0.5em;
	}
	&.selected {
		background-color: #c0d6ff;
	}
}
</style>